(function() {
  'use strict';

  angular
    .module('taglme', ['ngSanitize', 'ngMessages', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr',
                       'ngPassword', 'http-auth-interceptor', 'pascalprecht.translate', 'ngCookies', 'rt.asyncseries',
                       'toggle-switch', 'ng-sortable', 'duScroll', 'ngAnimate']);

})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .service('TagConfigService', TagConfigService)
        .service('TagConfigExport', TagConfigExport);

    /** @ngInject */
    function TagConfigService(APIURL, $resource, $http) {
        var cfgRes = $resource(APIURL + '/deploy/encodings/:encodingId/tagconfigs/:id', {}, {
            'update': { method: 'PUT' },
        });

        return {
            getOptionalFieldsFromTagConfig: function(tagConfig) {
                var result = _.pick(tagConfig,
                    'name', 'tagConfigType', 'encodingOrder', 'locked', 'powerValue',
                    'broadCastRate', 'password', 'targetManufacturer', 'targetModel',
                    'referenceTag');
                if (tagConfig.loadInstructions) {
                    result.encodingQuantity = tagConfig.loadInstructions.encodingQuantity;
                } else {
                    result.encodingQuantity = 1;
                }


                return result;
            },

            create: function(encodingId, configType, optionalFields, requiredFields) {
                var params = _.clone(optionalFields) || {};
                params.payloadDataType = configType;
                params.payloadData = requiredFields;
                return cfgRes.save({ encodingId: encodingId }, params).$promise;
            },

            query: function(encodingId, limit, offset) {
                var params = {
                    limit: limit,
                    offset: offset,
                    encodingId: encodingId
                };

                return cfgRes.get(params).$promise;
            },

            getEncoder: function(id) {
                return cfgRes.get({ id: id }).$promise;
            },

            remove: function(encodingId, id) {
                return cfgRes.remove({ encodingId: encodingId, id: id }).$promise;
            },

            update: function(encodingId, tagconfigId, configType, optionalFields, requiredFields) {
                var params = _.clone(optionalFields) || {};
                params.payloadDataType = configType;
                params.payloadData = requiredFields;

                return cfgRes.update({
                    encodingId: encodingId,
                    id: tagconfigId
                }, params).$promise;
            },

            updateMulti: function(encodingId, tagconfigs) {
                return $http.patch(APIURL + '/deploy/encodings/' + encodingId + '/tagconfigs/tx ', tagconfigs);
            },

            createMulti: function(encodingId, tagconfigs) {
                return $http.post(APIURL + '/deploy/encodings/' + encodingId + '/tagconfigs/tx ', tagconfigs);
            },

            deleteMulti: function(encodingId, tagconfigs) {
                return $http.delete(APIURL + '/deploy/encodings/' + encodingId + '/tagconfigs/tx ', tagconfigs);
            },

        };
    }

    /** @ngInject */
    function TagConfigExport(TagConfigService, TAG_CONFIG_STRUCT) {
        return {
            export: exportTagConfigs
        };

        function exportTagConfigs(tagconfigs, filename) {
            var exportFileName = filename || 'tagconfig.json';

            if (tagconfigs.length === 1) {
                var tagconfigType = tagconfigs[0].payloadDataType,
                    encoderType = tagconfigs[0].tagConfigType,
                    tagConfigTemplate = TAG_CONFIG_STRUCT[encoderType].types[tagconfigType];

                exportFileName = tagConfigTemplate.exportFile;
            }

            var items = _.map(tagconfigs, function(tagconfig) {
                return tagconfig2Json(tagconfig);
            });

            var stringifiedItems = angular.toJson(items, true);

            exportFile(exportFileName, 'application/json;charset=utf-8;', stringifiedItems);
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function tagconfig2Json(tagconfig) {
            var tagconfigType = tagconfig.payloadDataType,
                encoderType = tagconfig.tagConfigType,
                template = TAG_CONFIG_STRUCT[encoderType],
                tagConfigTemplate = template.types[tagconfigType],
                requiredData = tagconfig.payloadData,
                requiredFieldsStruct = tagConfigTemplate.fields,
                exportType = tagConfigTemplate.exportType,
                optionalData = TagConfigService.getOptionalFieldsFromTagConfig(tagconfig),
                optionalFieldsStruct = template.optional,
                json = {};

            json.RecordType = exportType;

            _.each(requiredFieldsStruct, function(field, fieldname) {

                var key = field.exportAs || capitalizeFirstLetter(fieldname);
                if (!_.isNull(key)) {
                    json[key] = requiredData[fieldname];
                }
            });

            _.each(optionalFieldsStruct, function(field, fieldname) {
                var key = field.exportAs || capitalizeFirstLetter(fieldname);
                if (!_.isNull(key)) {
                    json[key] = optionalData[fieldname];
                }
            });

            return json;
        }

        /* eslint-disable */
        function exportFile(filename, contentType, content) {
            var blob = new Blob([content], { type: contentType });

            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");

                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = window.URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }
        /* eslint-enable */
    }
})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .filter('prettyJson', prettyJson);


  /** @ngInject */
  function prettyJson() {
    return function (obj, pretty) {
      if (!obj) {
        return '';
      }
      var json = angular.toJson(obj, pretty);
      if (!pretty) {
        return json;
      }
      return json
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
          var cls;
          if (/^"/.test(match)) {
            cls = /:$/.test(match) ? 'key' : 'string';
          } else if (/true|false/.test(match)) {
            cls = 'boolean';
          } else if (/null/.test(match)) {
            cls = 'null';
          } else {
            cls = 'number';
          }
          return '<span class="json-' + cls + '">' + match + '</span>';
        });
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('TagConfigController', TagConfigController);

    /** @ngInject */
    function TagConfigController($scope, $stateParams, EncodingsService, TagConfigService, tagConfigItemModal,
        $translate,
        TagConfigExport,
        errorHandler, toastrInfo, TAG_CONFIG_STRUCT, eachSeries, toastr) {
        var vm = this;

        var encodingId = $stateParams.id;

        var LC_LIMIT_KEY = 'table_configs_limit',
            DEFAULT_LIMIT = 10;

        vm.encodersTypes = [
            'nfcTag',
            'beacon'
        ];
        console.log(localStorage);
        vm.selected = {}; // id -> boolean
        vm.hasSelection = false;
        vm.encodings = [];

        vm.limit = localStorage.getItem(LC_LIMIT_KEY) || DEFAULT_LIMIT;
        // set items per page. save in storage
        vm.setLimit = function(newLimit) {
            localStorage.setItem(LC_LIMIT_KEY, newLimit);
            vm.limit = newLimit;
            vm.page = 1;
            populateTable();
        };

        vm.offset = 0;
        vm.page = 1;

        vm.loadingTable = false; // once for populating table
        vm.updating = false; // set true before some api call and populate table

        var orderBeforeDrag = [];

        vm.sortOptions = {
            animation: 150,
            chosenClass: "chosen-cfg",
            handle: ".handle-row",
            onStart: function() {
                orderBeforeDrag = _.clone(vm.tagConfigs);
            },
            onEnd: function( /**Event*/ evt) {
                var oldIndex = evt.oldIndex,
                    newIndex = evt.newIndex,
                    oldTag = orderBeforeDrag[oldIndex],
                    newTag = orderBeforeDrag[newIndex],
                    txOld = _.pick(oldTag, ['id', 'encodingOrder']),
                    txNew = _.pick(newTag, ['id', 'encodingOrder']),
                    encodingId = vm.encoderId;

                txOld.encodingOrder = txNew.encodingOrder;
                var tx = [txOld];

                TagConfigService.updateMulti(encodingId, tx)
                    .then(populateTable)
                    .catch(errorHandler($translate.instant('CONFIGS_UPDATE_FAILED')));
            },
        };

        vm.isLoading = function() {
            return vm.loadingTable || vm.updating;
        };

        // populating table will remove selected items and remote loading flags
        function populateTable() {
            vm.selected = {};
            vm.hasSelection = false;
            //vm.copied = [];
            checkCopiedConfigs();

            if (vm.loadingTable) {
                return;
            }

            var limit = vm.limit,
                page = vm.page - 1, // paginator start from 1
                offset = page * limit;

            var applyLoadedData = function(res) {

                vm.tagConfigs = res.items; // table rows
                vm.total = res.total;
                console.log(vm.tagConfigs);
            };

            vm.loadingTable = true;
            TagConfigService.query(encodingId, limit, offset)
                .then(applyLoadedData)
                .finally(function() {
                    vm.updating = false;
                    vm.loadingTable = false;
                });
        }

        function setupScopeWithEncoder(encoder) {
            var encoderType = encoder.type,
                templateOfTagConfig = TAG_CONFIG_STRUCT[encoderType];
            vm.encoderType = encoderType;
            vm.encoder = encoder;
            vm.encoderId = encoder.id;
            vm.template = templateOfTagConfig;

            return encoder;
        }

        function setupTablePageWatcher() {
            $scope.$watch('tagcfg.page', populateTable);
        }

        function checkCopiedConfigs() {
            vm.copied = [];
            vm.hasClipboard = false;
            console.log("Check clipboard");
            console.log(localStorage.getItem('copiedConfigs'));
            if (localStorage.getItem('copiedConfigs')) {
                var configs = JSON.parse(localStorage.getItem('copiedConfigs'));
                console.log(configs);
                if (configs.length) {
                    vm.hasClipboard = true;
                    vm.copied = configs;
                }

            }
            return;
        };


        // bootstrap page data
        EncodingsService.getEncoder(encodingId)
            .then(setupScopeWithEncoder)
            .then(populateTable)
            .catch(errorHandler($translate.instant('CONFIGS_LOAD_FAILED')))
            .finally(setupTablePageWatcher);

        // return icon for tagConfigs by his type
        vm.icon = function(tagconfig) {
            var tagconfigType = tagconfig.payloadDataType,
                template = vm.template,
                icon = '';

            if (template && template.types && template.types[tagconfigType]) {
                icon = template.types[tagconfigType].icon;
            }

            return icon;
        };

        vm.typeDesc = function(tagconfig) {
            var tagconfigType = tagconfig.payloadDataType,
                template = vm.template,
                desc = '';

            if (template && template.types && template.types[tagconfigType]) {
                desc = template.types[tagconfigType].desc;
            }

            return desc;
        };

        vm.tglSelection = function(tagconfig) {
            console.log("Called selection");

            var id = tagconfig.id;
            console.log(vm.selected[id]);
            vm.selected[id] = !vm.selected[id];
            var selectedIds = getSelection();
            if (selectedIds.length) {
                vm.hasSelection = true;
            } else {
                vm.hasSelection = false;
            }
            console.log(vm.selected[id]);
        };

        vm.payloadView = function(tagconfig) {
            var template = vm.template,
                tagconfigType = tagconfig.payloadDataType,
                tagConfigTemplate = template.types[tagconfigType] || { fields: {} },
                requiredData = tagconfig.payloadData,
                requiredFieldsStruct = tagConfigTemplate.fields;

            var res = [];

            _.each(requiredFieldsStruct, function(field, fieldname) {
                var showField = field.contentShow;

                // if undefined or true
                if (_.isUndefined(showField) || showField) {
                    res.push(requiredData[fieldname]);
                }
            });

            return res.join(', ');
        };

        vm.showCreateModal = function(type) {
            tagConfigItemModal.create(vm.encoderType, type)
                .then(function(data) {
                    var encoderId = vm.encoderId,
                        optionalFields = data.optional,
                        requiredFields = data.required;

                    TagConfigService.create(encoderId, type, optionalFields, requiredFields)
                        .catch(errorHandler($translate.instant('CONFIGS_CREATE_FAILED')))
                        .finally(populateTable);
                });
        };

        function getSelection() {
            var selected = vm.selected;
            var ids = _.keys(selected);

            return _.filter(ids, function(id) {
                return selected[id];
            });
        }

        vm.deleteSelected = function() {
            var selected = getSelection(),
                encodingId = vm.encoderId;

            if (selected.length) {
                tagConfigItemModal.deleteSelected().then(function() {
                    vm.updating = true;
                    eachSeries(selected, function(id) {
                        return TagConfigService.remove(encodingId, id).catch(errorHandler($translate.instant('CONFIGS_REMOVE_FAILED')));
                    }).finally(populateTable);
                });

            }
        };

        vm.copyEncodings = function() {
            var selectedIds = getSelection(),
                tagConfigs = vm.tagConfigs;

            console.log(selectedIds);

            if (selectedIds.length) {
                var selected = _.map(selectedIds, function(id) {
                    return _.cloneDeep(_.findWhere(tagConfigs, { id: id }));
                });
                vm.copied = selected;
                localStorage.setItem('copiedConfigs', JSON.stringify(vm.copied));
                vm.hasClipboard = true;
                console.log(vm.copied);
                toastr.info($translate.instant('CONFIGS_COPIED'));
            }
        };

        vm.pasteConfigs = function() {
            var copied = vm.copied,
                encodingId = vm.encoderId;
            if (vm.copied.length) {
                vm.updating = true;
                vm.copied = [];
                localStorage.setItem('copiedConfigs', JSON.stringify(vm.copied));
                console.log(localStorage.getItem('copiedConfigs'));
                vm.hasClipboard = false;

                TagConfigService.createMulti(encodingId, copied)
                    .then(toastrInfo($translate.instant('CONFIGS_PASTED')))
                    .catch(errorHandler($translate.instant('CONFIGS_CREATE_FAILED')))
                    .finally(populateTable);

            }
        };

        vm.selectAll = function() {
            vm.selected = {};
            _.each(vm.tagConfigs, function(config) {
                var id = config.id;
                vm.selected[id] = true;
            });
            vm.hasSelection = true;
        };

        vm.edit = function(tagConfig) {
            if (_.isObject(tagConfig)) {

                var encodingType = vm.encoderType,
                    configType = tagConfig.payloadDataType,
                    optional = TagConfigService.getOptionalFieldsFromTagConfig(tagConfig),
                    required = _.clone(tagConfig.payloadData);

                tagConfigItemModal
                    .edit(encodingType, configType, optional, required)
                    .then(function(modalRes) {
                        var newOptional = modalRes.optional,
                            newRequired = modalRes.required,
                            tagconfigId = tagConfig.id;

                        TagConfigService.update(encodingId, tagconfigId, configType, newOptional, newRequired)
                            .catch(errorHandler($translate.instant('CONFIGS_UPDATE_FAILED')))
                            .finally(populateTable);
                    });
            }
        };

        vm.view = function(tagConfig) {
            if (_.isObject(tagConfig)) {

                var encodingType = vm.encoderType,
                    configType = tagConfig.payloadDataType,
                    optional = TagConfigService.getOptionalFieldsFromTagConfig(tagConfig),
                    required = _.clone(tagConfig.payloadData);

                tagConfigItemModal
                    .view(encodingType, configType, optional, required)
                    .then(function(modalRes) {

                    });
            }
        };



        vm.deleteItem = function(id) {
            if (id) {
                tagConfigItemModal.delete().then(function() {
                    var encodingId = vm.encoderId;
                    TagConfigService.remove(encodingId, id)
                        .catch(errorHandler($translate.instant('CONFIGS_REMOVE_FAILED')))
                        .finally(populateTable);
                });

            }
        };

        vm.exportSelected = function() {
            var selectedIds = getSelection(),
                tagConfigs = vm.tagConfigs,
                template = vm.template,
                filename = template.exportFile;

            var items = _.map(selectedIds, function(id) {
                var cfg = _.findWhere(tagConfigs, { id: id });
                return cfg;
            });

            TagConfigExport.export(items, filename);
        };

        vm.exportItem = function(tagconfig) {
            TagConfigExport.export([tagconfig]);
        };
    }
})();
(function() {
    'use strict';

    /*
     * {'nfsTag'|'beacon'}.{'types'|'optional'}
     *
     * exportType, exportFile, exportAs used for export json
     *
     * WARNING:  if  API  will  be changed,  and  changed  field,  check
     * https://gototags.com/technology/nfc/ndef  for  appropriate  field
     * name ('exportAs', 'exportType')
     *
     * By default 'exportAs' is camelised field name
     *
     * 'contentShow'  - default true, show in field in "content" column of tagconfig table
     *
     */
    var TAG_CONFIG_STRUCT = {

        //nfc
        'nfcTag': {
            exportFile: 'configs.nfc',
            types: {
                'url': {
                    icon: 'fa-link',
                    desc: 'URL_TYPE',
                    exportFile: 'url_payload.nfc',
                    exportType: 'Website',
                    fields: {
                        'url': { desc: 'CONFIG_URL', type: 'text', require: true, placeholder: 'CONFIG_URL_PLACEHOLDER' },
                    },
                },
                'text': {
                    icon: 'fa-align-left',
                    desc: 'TEXT_TYPE',
                    exportFile: 'text_payload.nfc',
                    exportType: 'Text',
                    fields: {
                        'text': { desc: 'CONFIG_TEXT', type: 'textarea', placeholder: 'CONFIG_TEXT_PLACEHOLDER', require: true },
                    }
                },
                'uri': {
                    icon: 'fa-link',
                    desc: 'URI_TYPE',
                    exportFile: 'uri_payload.nfc',
                    exportType: 'Uri',
                    fields: {
                        'uri': { desc: 'CONFIG_URI', type: 'text', require: true, placeholder: 'CONFIG_URI_PLACEHOLDER' },
                    },
                },
                'vcard': {
                    icon: 'fa-id-card-o',
                    desc: 'VCARD_TYPE',
                    exportFile: 'vcard_payload.nfc',
                    exportType: 'Contact',
                    fields: {
                        'firstName': { desc: 'CONFIG_FIRST_NAME_VCARD', type: 'text', require: true, placeholder: 'CONFIG_FIRST_NAME_VCARD_PLACEHOLDER' },
                        'lastName': { desc: 'CONFIG_LAST_NAME_VCARD', type: 'text', require: false, placeholder: 'CONFIG_LAST_NAME_VCARD_PLACEHOLDER' },
                        'organization': { desc: 'CONFIG_ORGANIZATION_VCARD', type: 'text', require: false, placeholder: 'CONFIG_ORGANIZATION_VCARD_PLACEHOLDER', contentShow: false },
                        'title': { desc: 'CONFIG_TITLE_VCARD', type: 'text', require: false, placeholder: 'CONFIG_TITLE_VCARD_PLACEHOLDER', contentShow: false },
                        'email': { desc: 'CONFIG_EMAIL_VCARD', type: 'email', require: false, placeholder: 'CONFIG_EMAIL_VCARD_PLACEHOLDER', contentShow: false },
                        'phoneHome': { desc: 'CONFIG_HOME_PHONE_VCARD', type: 'text', require: false, placeholder: 'CONFIG_HOME_PHONE_VCARD_PLACEHOLDER', contentShow: false },
                        'phoneWork': { desc: 'CONFIG_WORK_PHONE_VCARD', type: 'text', require: false, placeholder: 'CONFIG_WORK_PHONE_VCARD_PLACEHOLDER', contentShow: false },
                        'phoneCell': { desc: 'CONFIG_CELL_PHONE_VCARD', type: 'text', require: false, placeholder: 'CONFIG_CELL_PHONE_VCARD_PLACEHOLDER', contentShow: false },
                        'addressCountry': {
                            desc: 'CONFIG_COUNTRY_VCARD',
                            type: 'text',
                            require: false,
                            placeholder: 'CONFIG_COUNTRY_VCARD_PLACEHOLDER',
                            exportAs: 'AddressWorkCountry',
                            contentShow: false
                        },
                        'addressPostalCode': {
                            desc: 'CONFIG_POSTAL_CODE_VCARD',
                            type: 'text',
                            require: false,
                            placeholder: 'CONFIG_POSTAL_CODE_VCARD_PLACEHOLDER',
                            exportAs: 'AddressWorkPostalCode',
                            contentShow: false
                        },
                        'addressRegion': {
                            desc: 'CONFIG_REGION_VCARD',
                            type: 'text',
                            require: false,
                            placeholder: 'CONFIG_REGION_VCARD_PLACEHOLDER',
                            exportAs: 'AddressWorkRegion',
                            contentShow: false
                        },
                        'addressCity': {
                            desc: 'CONFIG_CITY_VCARD',
                            type: 'text',
                            require: false,
                            placeholder: 'CONFIG_CITY_VCARD_PLACEHOLDER',
                            exportAs: 'AddressWorkCity',
                            contentShow: false
                        },
                        'addressStreet': {
                            desc: 'CONFIG_STREET_VCARD',
                            type: 'text',
                            require: false,
                            placeholder: 'CONFIG_STREET_VCARD_PLACEHOLDER',
                            exportAs: 'AddressWorkStreet',
                            contentShow: false
                        },
                    },
                },
                'mime': {
                    icon: 'fa-file-code-o',
                    desc: 'MIME_TYPE',
                    exportFile: 'mime_payload.nfc',
                    exportType: 'MimeType',
                    fields: {
                        'contentType': { desc: 'CONFIG_CONTENT_TYPE', type: 'text', require: true, placeholder: 'CONFIG_CONTENT_TYPE_PLACEHOLDER', exportAs: 'MimeType' },
                        'content': { desc: 'CONFIG_CONTENT', type: 'textarea', require: true, placeholder: 'CONFIG_CONTENT_PLACEHOLDER', exportAs: 'PayloadASCII' }
                    },
                },
                'phone': {
                    icon: 'fa-phone',
                    desc: 'PHONE_TYPE',
                    exportFile: 'phone_payload.nfc',
                    exportType: 'Phone',
                    fields: {
                        'phoneNumber': { desc: 'CONFIG_PHONE', type: 'text', require: true, placeholder: 'CONFIG_PHONE_PLACEHOLDER', exportAs: 'Number' },
                    }
                },
                'geo': {
                    icon: 'fa-map-marker',
                    desc: 'GEO_TYPE',
                    exportFile: 'geo_payload.nfc',
                    exportType: 'Geo',
                    fields: {
                        'latitude': { desc: 'CONFIG_LATITUDE', type: 'text', placeholder: 'CONFIG_LATITUDE_PLACEHOLDER', require: true },
                        'longitude': { desc: 'CONFIG_LONGITUDE', type: 'text', placeholder: 'CONFIG_LONGITUDE_PLACEHOLDER', require: true },
                    },
                },
                'aar': {
                    icon: 'fa-android',
                    desc: 'ANDROID_TYPE',
                    exportFile: 'aar_payload.nfc',
                    exportType: 'AAR',
                    fields: {
                        'packageName': { desc: 'CONFIG_PACKAGE_NAME', type: 'text', require: true, placeholder: 'CONFIG_PACKAGE_PLACEHOLDER', exportAs: 'Package' },
                    },
                },
                'poster': {
                    icon: 'fa-picture-o',
                    desc: 'SMARTPOSTER_TYPE',
                    exportFile: 'poster_payload.nfc',
                    exportType: 'Website',
                    fields: {
                        'uri': { desc: 'CONFIG_URI', type: 'text', require: true, placeholder: 'CONFIG_URI_PLACEHOLDER', exportAs: 'Url' },
                        'title': { desc: 'CONFIG_TITLE', type: 'text', require: true, placeholder: 'CONFIG_TITLE_PLACEHOLDER' },
                    },
                }
            }, // end types
            optional: {
                'name': { desc: 'CONFIG_NAME', type: 'text', require: false, placeholder: 'CONFIG_NAME_PLACEHOLDER' },

                'encodingQuantity': { desc: 'CONFIG_QUANTITY', type: 'number', require: false, placeholder: 'CONFIG_QUANTITY_PLACEHOLDER' },
                'encodingOrder': { desc: 'CONFIG_ORDER', type: 'number', require: false, placeholder: 'CONFIG_ORDER_PLACEHOLDER' },
                'locked': { desc: 'CONFIG_LOCK', type: 'boolean', require: false },
                //'password': { desc: 'ACCESS PASSWORD TO NFC TAG', type: 'text', require: false },
                'targetManufacturer': { desc: 'CONFIG_MANUFACTURER', type: 'text', require: false, placeholder: 'CONFIG_MANUFACTURER_PLACEHOLDER' },
                'targetModel': { desc: 'CONFIG_MODEL', type: 'text', require: false, placeholder: 'CONFIG_MODEL_PLACEHOLDER' },
            }
        },

        // beacon
        'beacon': {
            exportFile: 'configs.beacon',
            types: {
                'ibeacon': {
                    icon: 'fa-wifi',
                    desc: 'IBEACON RECORD',
                    exportFile: 'ibeacon_payload.beacon',
                    exportType: 'Ibeacon',
                    fields: {
                        name: {
                            desc: 'IBEACON_NAME',
                            type: 'text',
                            require: true,
                            placeholder: 'Beacon',
                            exportAs: 'ProximityName'
                        },
                        proximityUuid: {
                            desc: 'PROXIMITY UUID',
                            type: 'text',
                            require: true,
                            placeholder: '6F9619FF-8B86-D011-B42D-00CF4FC964FF',
                            exportAs: 'ProximityUuid'
                        },
                        major: { desc: 'MAJOR', type: 'text', placeholder: '1', require: true },
                        minor: { desc: 'MINOR', type: 'text', placeholder: '1', require: true },
                    },
                },
                'uribeacon': {
                    icon: 'fa-wifi',
                    desc: 'URIBEACON RECORD',
                    exportFile: 'uribeacon_payload.beacon',
                    exportType: 'Uribeacon',
                    fields: {
                        'name': {
                            desc: 'URIBEACON_NAME',
                            type: 'text',
                            require: true,
                            placeholder: 'Beacon',
                            exportAs: 'ProximityName'
                        },
                        'proximityUrl': {
                            desc: 'PROXIMITY URL',
                            type: 'text',
                            require: true,
                            placeholder: 'http://example.com',
                            exportAs: 'ProximityUrl'
                        }
                    }
                },
            }, // end types
            optional: {
                'name': { desc: 'NAME OF BEACON TAG CONFIGURATION', type: 'text', require: false },
                'encodingOrder': { desc: 'ORDER OF CONFIGURATION ENCODING', type: 'number', require: false },
                'powerValue': { desc: 'BROADCASTING POWER LEVEL 0-100%', type: 'number', require: false },
                'broadCastRate': { desc: 'BROADCASTING RATE IN MS', type: 'number', require: false, exportAs: 'BroadcastRate' },
                'password': { desc: 'ACCESS PASSWORD TO BEACON TAG', type: 'text', require: false },
                'targetManufacturer': { desc: 'MANUFACTURER OF BEACON TAG', type: 'text', require: false },
                'targetModel': { desc: 'MODEL OF BEACON TAG', type: 'text', require: false },
            },
        }
    };

    angular
        .module('taglme')
        .constant('TAG_CONFIG_STRUCT', TAG_CONFIG_STRUCT);

})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('ConfigrmResetPasswordController', ConfigrmResetPasswordController);

    /** @ngInject */
    function ConfigrmResetPasswordController(LoginAuth, $state, $stateParams, errorHandler, toastr, $translate) {
        var vm = this;

        vm.code = $stateParams.activateCode;

        vm.confirmReset = function(code, newPassword) {
            LoginAuth.confirmResetPassword(code, newPassword)
                .then(function() {
                    $state.go('login');
                    toastr.success($translate.instant('ACCOUNT_PASSWORD_CHANGED'));
                })
                .catch(errorHandler($translate.instant('ACCOUNT_PASSWORD_CHANGE_FAILED')));

        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .service('tagConfigItemModal', tagConfigItemModal);

    /** @ngInject */
    function tagConfigItemModal($modal) {
        return {
            create: function(encoderType, configType) {
                var modalInstance = $modal.open({
                    animation: false,
                    templateUrl: 'app/modals/tagconfig/createTag.html',
                    controller: 'CreateTagConfigModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        data: {
                            encoderType: encoderType,
                            configType: configType,
                            edit: false
                        }
                    }
                });

                return modalInstance.result; // promise
            },
            edit: function(encoderType, configType, optional, required) {
                var modalInstance = $modal.open({
                    animation: false,
                    templateUrl: 'app/modals/tagconfig/createTag.html',
                    controller: 'CreateTagConfigModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        data: {
                            encoderType: encoderType,
                            configType: configType,
                            optional: optional,
                            required: required,
                            edit: true
                        }
                    }
                });

                return modalInstance.result; // promise
            },
            view: function(encoderType, configType, optional, required) {
                var modalInstance = $modal.open({
                    animation: false,
                    templateUrl: 'app/modals/tagconfig/viewTag.html',
                    controller: 'CreateTagConfigModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        data: {
                            encoderType: encoderType,
                            configType: configType,
                            optional: optional,
                            required: required,
                            edit: true
                        }
                    }
                });

                return modalInstance.result; // promise
            },

            delete: function() {
                var modalInstance = $modal.open({
                    animation: false,
                    templateUrl: 'app/modals/tagconfig/deleteTag.html',
                    controller: 'CreateTagConfigModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        data: {}
                    }
                });

                return modalInstance.result; // promise
            },
            deleteSelected: function() {
                var modalInstance = $modal.open({
                    animation: false,
                    templateUrl: 'app/modals/tagconfig/deleteTags.html',
                    controller: 'CreateTagConfigModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        data: {}
                    }
                });

                return modalInstance.result; // promise
            },

        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('CreateTagConfigModalController', CreateTagConfigModalController);

    /** @ngInject */
    function CreateTagConfigModalController($modalInstance, data, TAG_CONFIG_STRUCT) {
        var vm = this;
        console.log(data);
        console.log(TAG_CONFIG_STRUCT);
        if (data.configType) {
            var configType = data.configType,
                encoderType = data.encoderType,
                template = TAG_CONFIG_STRUCT[encoderType],
                info = vm.info = template.types[configType];

            vm.requiredFields = info.fields;
            vm.optionalFields = template.optional;
            vm.optional = data.optional;
            vm.required = data.required;
            vm.showOptions = false;

        }
        vm.toogleOptions = function() {
            vm.showOptions = !vm.showOptions;
        }

        vm.ok = function() {
            console.log(vm);
            if (vm.optional && vm.optional.encodingQuantity) {
                var loadInstructions = {
                    encodingQuantity: vm.optional.encodingQuantity
                };
                vm.optional.loadInstructions = loadInstructions;
            }

            $modalInstance.close({
                required: vm.required,
                optional: vm.optional,
            });
        };

        vm.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .service('encodeItemModal', encodeItemModal);

    /** @ngInject */
    function encodeItemModal($modal) {
        return {
            create: function() {
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: 'app/modals/encode/create.html',
                    controller: 'CreateEncodeModalController',
                    controllerAs: 'vm',
                    resolve: {
                        data: {
                            edit: false
                        }
                    }
                });

                return modalInstance.result; // promise
            },
            edit: function(name, description) {
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: 'app/modals/encode/create.html',
                    controller: 'CreateEncodeModalController',
                    controllerAs: 'vm',
                    resolve: {
                        data: {
                            name: name,
                            description: description,
                            edit: true
                        }
                    }
                });

                return modalInstance.result; // promise
            },

            delete: function() {
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: 'app/modals/encode/delete.html',
                    controller: 'CreateEncodeModalController',
                    controllerAs: 'vm',
                    resolve: {
                        data: {
                            edit: false
                        }
                    }
                });

                return modalInstance.result; // promise
            },

        };
    }
})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .controller('CreateEncodeModalController', CreateEncodeModalController);

  /** @ngInject */
  function CreateEncodeModalController($modalInstance, data) {
    var vm = this;

    vm.name = data.name;
    vm.editing = data.edit;
    vm.description = data.description;

    vm.ok = function (name, description) {
      $modalInstance.close({
        name: name,
        description: description
      });
    };

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('taglme')
    .service('TokenInterceptor', TokenInterceptor);

  /** @ngInject */
  function TokenInterceptor($q, tokenStorage) {
    return {
      // Add Authorization header if user signed in
      request: function (config) {
        config.headers = config.headers || {};
        if (tokenStorage.userToken()) {
          config.headers.Authorization = 'Bearer ' + tokenStorage.userToken();
        }
        return config;
      }
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .directive('acmeNavbar', acmeNavbar);

    /** @ngInject */
    function acmeNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(moment, currentUser, $scope, $state,
            LoginAuth, LANGUAGES, $translate) {
            var vm = this;

            vm.languages = LANGUAGES;

            vm.currentLang = $translate.use();

            $scope.$on('user:updated', function(e, currentUser) {
                vm.userName = currentUser && currentUser.name;
            });

            vm.$state = $state;

            vm.setLanguage = function(language) {
                $translate.use(language);
                vm.currentLang = $translate.use();
            };

            vm.logout = function() {
                LoginAuth.logout();
                $state.go('login');
            };
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .service('LangInterceptor', LangInterceptor);

    /** @ngInject */
    function LangInterceptor($q) {
        return {
            // Add Authorization header if user signed in
            request: function(config) {
                config.headers['Accept-Language'] = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                return config;
            }
        };
    }
})();
(function() {
    'use strict';

    // english language
    var lang_en = {
        'PLEASE_SIGN_IN': 'Please Sign In',
        'USERNAME_SIGN': 'Username',
        'PASSWORD_SIGN': 'Password',
        'PASSWORD_NEW': 'New password',
        'REMEMBER_ME': 'Remember Me',
        'LOGIN': 'Login',
        'SIGNUP': 'Signup',
        'USER_PROFILE': 'User profile',
        'LOGOUT': 'Logout',
        'CREATE_NEW_ACCOUNT': 'Create New Account',
        'EMAIL': 'E-mail',
        'CONFIRM_PASSWORD': 'Confirm password',
        'PASSWORD_DID_NOT_MATCH': 'Your passwords did not match',
        'ENTER_ACTIVATION_CODE': 'Enter activation code',
        'ACTIVATE_CODE': 'Activation code',
        'FINISH_REGISTRATION': 'Finish registration',
        'RESET_PASSWORD': 'Reset password',
        'SEND_RESET_CODE': 'Send reset code',
        'CONFIRM_RESET_PASSWORD': 'Reset password',
        'SUBMIT_RESET_CODE': 'Submit',
        'FORGOT_PASSWORD': 'Forgot Password?',
        'RESET_CODE': 'Reset code',

        'USR_SETTINGS': 'Account',
        'USR_SETTINGS_HINT': 'You can change some settings',
        'YOUR_LOGIN_NAME': 'Your login name',
        'EMAIL_ADDRESS': 'Email address',
        'ACCOUNT_PLAN': 'Account Plan',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'RESET': 'Reset',
        'RETURN': 'Back',
        'CHANGE_PASSWORD': 'Change password',
        'CHANGE_PASSWORD_HINT': 'In order to change password please enter your current password and desired password below',
        'CURRENT_PASSWORD': 'Current password',
        'OLD_PASSWORD': 'Old password',
        'NEW_PASSWORD': 'New Password',
        'REPEAT_PASSWORD': 'Repeat password',
        'SAVE_PASSWORD': 'Change password',
        'ACTIVATION_HINT_MSG': 'Please copy the activation code sent to your email address here.',
        'ASK_RESEND_ACTIVATION_EMAIL': 'Resend activation email?',
        'RESEND_ACTIVATION_EMAIL': 'Resend activation email',
        'GO_BACK_TO_ACTIVATE_PAGE': 'Go back to activate page',
        'SUBMIT_SENDING': 'Send', // submit button, resend activation page
        'YOUR_PASSWORD_TOO_SHORT': 'Your password is too short',
        'YOUR_PASSWORD_TOO_BIG': 'Your password too big',

        'ENCODINGS': 'Encodings',

        'PREVIOUS': 'Previous',
        'NEXT': 'Next',
        'FIRST': 'First',
        'LAST': 'Last',

        // todo translate //

        // sidebar
        'DASHBOARD': 'Dashboard',
        'DEPLOY': 'Deploy',

        // menu items
        'CREATE_NEW_NFC': 'New NFC encoding',
        'CREATE_NEW_BEACON': 'New Beacon encoding',

        // enc types:
        'T_NFC': 'NFC',
        'T_BEACON': 'Beacon',

        'ENCODING_TEMPLATES': 'Encoding templates',
        'CREATE': 'Create',
        'ENCODING_LIST': 'Configuration groups',
        'DELETE': 'Delete',
        'COPY': 'Copy',
        'PASTE': 'Paste',
        'SELECT_ALL': 'Select all',
        'MORE': 'More',
        'ACTION': 'Action',
        'EDIT': 'Edit',
        'EXPORT': 'Export',
        'EXPORT_SELECTED': 'Export selected',

        // create modal
        'CREATE_ENCODING': 'Add new group',
        'EDIT_ENCODING': 'Edit group',
        'ENTER_ENCODING_NAME': 'Name',
        'ENTER_ENCODING_DESCRIPTION': 'Description',
        'SHOW': 'Show',
        'NAME': 'Name',
        'TYPE': 'Type',
        'CONFIGS': 'Configurations',
        'CREATED_AT': 'Created',
        'ACTIONS': 'Actions',

        // tagconfigs
        'EDIT_TAG_CONFIGS': 'Edit group configarations',
        'CONFIGS_TEMPLATES': 'Configs templates',
        'CONFIGS_LIST': 'Tag configurations',
        'CREATE_CONFIG': 'Create configuration',
        'EDIT_CONFIG': 'Edit configuration',
        'OPTIONAL_FIELDS': 'Encoding options',
        'CONTENT_FIELDS': 'Content',

        'ORDER': 'Order',
        'CONTENT': 'Content',
        'LOCK': 'Lock',

        'PLAIN TEXT RECORD': 'Text record',
        'TEXT': 'Text',
        'URL': 'URL',
        'URI': 'URI',
        'PACKAGE NAME': 'Package name',
        'URL RECORD': 'URL record',
        'URL RECORD WITH "HTTP" OR "HTTPS" SCHEMA': 'URL record with "http" or "https" schema',
        'URL RECORD WITH CUSTOM SCHEMA': 'URI record',
        'ANDROID APPLICATION RECORD': 'Android application record',
        'BUSINESS CARD RECORD': 'Business card record',
        'FIRST NAME': 'First name',
        'LAST NAME': 'Last name',
        'ORGANIZATION': 'Organization',
        'JOB_TITLE': 'Title',
        'HOME PHONE': 'Home phone',
        'WORK PHONE': 'Work phone',
        'CELL PHONE': 'Cell phone',
        'COUNTRY': 'Country',
        'POSTAL CODE': 'Postal code',
        'REGION': 'Region',
        'CITY': 'City',
        'STREET': 'Street',
        'CUSTOM MIME TYPE RECORD': 'Mime type record',
        'SMART POSTER RECORD': 'Smart poster record',
        'TITLE': 'Title',
        'GEO LOCATION RECORD': 'Geo location record',
        'LATITUDE': 'Latitude',
        'LONGITUDE': 'Longitude',
        'PHONE NUMBER RECORD': 'Phone number record',
        'PHONE NUMBER': 'Phone number',
        'NAME OF NFC TAG CONFIGURATION': 'Name of NFC tag configuration',
        'ORDER OF CONFIGURATION IN ENCODING': 'Сonfiguration order in group',
        'LOCK NFC TAG DURING ENCODING': 'Lock NFC tag',
        'ACCESS PASSWORD TO NFC TAG': 'Access password to NFC tag',
        'MANUFACTURER OF NFC TAG': 'Manufacturer of NFC tag',
        'MODEL OF NFC TAG': 'Model of NFC tag',
        'TEXT_CONFIG_PLACHOLDER': 'Message',
        'MIME_CONTENT': 'Content',
        'MIME_CONTENT_PLACHOLDER': 'Information',
        'SMARTPOSTER_TITLE_PLACHOLDER': 'Poster',
        'VCARD_FIRST_NAME_PLACHOLDER': 'John',
        'VCARD_LAST_NAME_PLACHOLDER': 'Doe',
        'VCARD_ORGANIZATION_PLACHOLDER': 'Bob Inc',
        'VCARD_TITLE_PLACHOLDER': 'MFCEO',
        'VCARD_EMAIL_PLACHOLDER': 'bob@home.com',
        'VCARD_PHONE_HOME_PLACHOLDER': '509-55-12',
        'VCARD_PHONE_WORK_PLACHOLDER': '509-55-12',
        'VCARD_PHONE_CELL_PLACHOLDER': '509-55-12',
        'VCARD_COUNTRY_PLACHOLDER': 'USA',
        'VCARD_POSTAL_CODE_PLACHOLDER': '123586',
        'VCARD_REGION_PLACHOLDER': 'WA',
        'VCARD_CITY_PLACHOLDER': 'Seattle',
        'VCARD_STREET_PLACHOLDER': '3302 Fuhrman Ave E.',


        'IBEACON RECORD': 'iBeacon record',
        'IBEACON_NAME': 'Name',
        'PROXIMITY UUID': 'Proximity UUID',
        'MAJOR': 'Major',
        'MINOR': 'Minor',
        'URIBEACON RECORD': 'uriBeacon record',
        'URIBEACON_NAME': 'Name',
        'PROXIMITY URL': 'Proximity URL',

        'NAME OF BEACON TAG CONFIGURATION': 'Name of Beacon tag configuration',
        'ORDER OF CONFIGURATION ENCODING': 'Сonfiguration order in group',
        'BROADCASTING POWER LEVEL 0-100%': 'Broadcasting power level, 0-100%',
        'BROADCASTING RATE IN MS': 'Broadcasting rate, ms',
        'ACCESS PASSWORD TO BEACON TAG': 'Access password to Beacon tag',
        'MANUFACTURER OF BEACON TAG': 'Manufacturer of Beacon tag',
        'MODEL OF BEACON TAG': 'Model of Beacon tag',

        // breadcrumbs
        'BR_ENCODINGS': 'Encodings',
        'BR_ALL': 'All',
        'BR_NFC': 'NFC',
        'BR_BEACON': 'Beacon',

        'MENU_NFC': 'Configurations',


        'I_AGREE_TO_THE_TERMS_AND_CONDITIONS': 'I agree to the terms and conditions',
        'TERMS_AND_CONDITIONS_TITLE': 'Terms and conditions',
        'TERMS_AND_CONDITIONS_HTML': '<h5>Last updated on: Apr 1, 2016 </h5>' +
            '<h4>1. Your Agreement with Tagl.me</h4>' +
            '<p>1.1 Your use of the Tagl.me service is governed by this agreement (the “Terms”). The “Tagl.me Services” means the services Tagl.me makes available through this website, including this website, the Tagl.me cloud computing service, the Tagl.me API, and any other software or services offered by Tagl.me in connection to any of those.</p>' +
            '<p>1.2 In order to use the Tagl.me Services, you must first agree to the Terms. You can agree to the Terms by actually using the Tagl.me Services. You understand and agree that Tagl.me will treat your use of the Tagl.me Services as acceptance of the Terms from that point onwards.</p>' +
            '<p>1.3 You may not use the Tagl.me Services if you are a person barred from receiving the Tagl.me Services under the laws of the Russian Federation or other countries, including the country in which you are resident or from which you use the Tagl.me Services. You affirm that you are over the age of 16, as the Tagl.me Services are not intended for children under 16.</p>' +
            '<p>1.4 You agree your purchases of Tagl.me Services are not contingent on the delivery of any future functionality or features or dependent on any oral or written public comments made by Tagl.me or any of its affiliates regarding future functionality or features.</p>' +
            '<h4>2. Your Account and Use of the Tagl.me Services</h4>' +
            '<p>2.1 You must provide accurate and complete registration information any time you register to use the Tagl.me Services. You are responsible for the security of your passwords and for any use of your account. If you become aware of any unauthorized use of your password or of your account, you agree to notify Tagl.me immediately.</p>' +
            '<p>2.2 Your use of the Tagl.me Services must comply with all applicable laws, regulations and ordinances, including any laws regarding the export of data or software.</p>' +
            '<p>2.3 You agree not to (a) access (or attempt to access) the administrative interface of the Tagl.me Services by any means other than through the interface that is provided by Tagl.me in connection with the Tagl.me Services, unless you have been specifically allowed to do so in a separate agreement with Tagl.me, or (b) engage in any activity that interferes with or disrupts the Tagl.me Services (or the servers and networks which are connected to the Service).</p>' +
            '<p>2.4 Your account has usage limits. The Tagl.me Services does not permit you to exceed the usage limits. Tagl.me reserves the right to enforce usage limits in its sole discretion, which may result in Tagl.me serving a “quota exceeded” page to you. Repeated exceeding of usage limits may lead to termination of your account.</p>' +
            '<h4>3. Fees for Use of the Tagl.me Services</h4>' +
            '<p>3.1 Subject to the Terms, the Tagl.me Services is provided to you without charge up to certain limits. Usage over this limit requires your purchase of additional resources or services. The pricing for additional resources and services can be found at http://tagl.me/#pricing (or such URL as Tagl.me may provide).</p>' +
            '<p>3.2 For all purchased resources and services, we will charge your credit card on a monthly basis or at the interval indicated in Tagl.me fees and payment policies, if different. To the fullest extent permitted by law, you waive all claims relating to charges unless claimed within 60 days after the charge (this does not affect your credit card issuer rights). Charges are solely based on Tagl.me’s measurements of your use of the Tagl.me Services, unless otherwise agreed to in writing. To the fullest extent permitted by law, refunds (if any) are at the discretion of Tagl.me and only in the form of credit for the Tagl.me Services. Nothing in these Terms obligates Tagl.me to extend credit to any party. You acknowledge and agree that any credit card and related billing and payment information that you provide to Tagl.me may be shared by Tagl.me with companies who work on Tagl.me’s behalf, such as payment processors and/or credit agencies, solely for the purposes of checking credit, effecting payment to Tagl.me and servicing your account. Tagl.me may also provide information in response to valid legal process, such as subpoenas, search warrants and court orders, or to establish or exercise its legal rights or defend against legal claims. Tagl.me shall not be liable for any use or disclosure of such information by such third parties. Tagl.me reserves the right to discontinue the provision of the Tagl.me Services to you for any late payments.</p>' +
            '<p>3.3 Tagl.me may change its fees and payment policies for the Tagl.me Services by notifying you at least fifteen (15) days before the beginning of the billing cycle in which such change will take effect. Changes to the fees or payment policies will be posted on the website (or such other URL Tagl.me may provide from time to time). Any outstanding balance becomes immediately due and payable upon termination of the Terms for any reason.</p>' +
            '<h4>4. Content on the Tagl.me Services and Take Down Obligations</h4>' +
            '<p>4.1 You understand that all information (such as data files, written text, computer software, music, audio files or other sounds, photographs, videos or other images) to which you may have access as part of, or through your use of, the Tagl.me Services are the sole responsibility of the person from which such content originated. All such information is referred to below as the “Content.” The term Content shall specifically exclude the web application that you create using the Tagl.me Services and any source code written by you to be used with the Tagl.me Services (collectively, “Applications”).</p>' +
            '<p>4.2 Tagl.me reserves the right (but shall have no obligation) to remove any or all Content from the Tagl.me Services. You agree to immediately take down any Content that violates the Acceptable Use Policy, including pursuant to a take down request from Tagl.me. In the event that you elect not to comply with a request from Tagl.me to take down certain Content, Tagl.me reserves the right to directly take down such Content or to disable Applications.</p>' +
            '<p>4.3 You agree that you are solely responsible for (and that Tagl.me has no responsibility to you or to any third party for) the Application or any Content that you create, transmit or display while using the Tagl.me Services and for the consequences of your actions (including any loss or damage which Tagl.me may suffer) by doing so.</p>' +
            '<p>4.4 You agree that Tagl.me has no responsibility or liability for the deletion or failure to store any Content and other communications maintained or transmitted through use of the Service. You further acknowledge that you are solely responsible for securing and backing up your Applications and any Content.</p>' +
            '<h4>5. Modification and Termination of the Tagl.me Services</h4>' +
            '<p>5.1 Tagl.me is constantly innovating in order to provide the best possible experience for its users. You acknowledge and agree that the form and nature of the Tagl.me Services which Tagl.me provides may change from time to time without prior notice to you. Changes to the form and nature of the Tagl.me Services will be effective with respect to all versions of the Tagl.me Services; examples of changes to the form and nature of the Tagl.me Services include without limitation changes to fee and payment policies, security patches, added functionality, and other enhancements.</p>' +
            '<p>5.2 You may terminate these Terms at any time by canceling your account on the Tagl.me Services. You will not receive any refunds if you cancel your account.</p>' +
            '<p>5.3 You agree that Tagl.me, in its sole discretion and for any or no reason, may terminate your account or any part thereof. You agree that any termination of your access to the Tagl.me Services may be without prior notice, and you agree that Tagl.me will not be liable to you or any third party for such termination.</p>' +
            '<p>5.4 You are solely responsible for exporting your Content and Application(s) from the Tagl.me Services prior to termination of your account for any reason, provided that if we terminate your account, we will provide you a reasonable opportunity to retrieve your Content and Application(s).</p>' +
            '<p>5.5 Upon any termination of the Tagl.me Services or your account these Terms will also terminate, but Sections 5, 6, 7, 8, 9 shall continue to be effective after these Terms are terminated.</p>' +
            '<h4>6. EXCLUSION OF WARRANTIES</h4>' +
            '<p>6.1 NOTHING IN THESE TERMS, INCLUDING SECTIONS 11 AND 12, SHALL EXCLUDE OR LIMIT TAGL.ME’S WARRANTY OR LIABILITY FOR LOSSES WHICH MAY NOT BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW.</p>' +
            '<p>6.2 YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE TAGL.ME SERVICE IS AT YOUR SOLE RISK AND THAT THE TAGL.ME SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE.”</p>' +
            '<p>6.3 TAGL.ME, ITS SUBSIDIARIES AND AFFILIATES, AND ITS LICENSORS MAKE NO EXPRESS WARRANTIES AND DISCLAIM ALL IMPLIED WARRANTIES REGARDING THE TAGL.ME SERVICES, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, TAGL.ME, ITS SUBSIDIARIES AND AFFILIATES, AND ITS LICENSORS DO NOT REPRESENT OR WARRANT TO YOU THAT: (A) YOUR USE OF THE TAGL.ME SERVICES WILL MEET YOUR REQUIREMENTS, (B) YOUR USE OF THE TAGL.ME SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR, AND (C) USAGE DATA PROVIDED THROUGH THE TAGL.ME SERVICES WILL BE ACCURATE.</p>' +
            '<h4>7. LIMITATION OF LIABILITY</h4>' +
            '<p>7.1 YOU EXPRESSLY UNDERSTAND AND AGREE THAT TAGL.ME, ITS SUBSIDIARIES AND AFFILIATES, AND ITS LICENSORS SHALL NOT BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL CONSEQUENTIAL OR EXEMPLARY DAMAGES WHICH MAY BE INCURRED BY YOU, HOWEVER CAUSED AND UNDER ANY THEORY OF LIABILITY. THIS SHALL INCLUDE, BUT NOT BE LIMITED TO, ANY LOSS OF PROFIT (WHETHER INCURRED DIRECTLY OR INDIRECTLY), ANY LOSS OF GOODWILL OR BUSINESS REPUTATION, ANY LOSS OF DATA SUFFERED, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR OTHER INTANGIBLE LOSS.</p>' +
            '<p>7.2 THE LIMITATIONS ON TAGL.ME’S LIABILITY TO YOU ABOVE SHALL APPLY WHETHER OR NOT TAGL.ME HAS BEEN ADVISED OF OR SHOULD HAVE BEEN AWARE OF THE POSSIBILITY OF ANY SUCH LOSSES ARISING.</p>' +
            '<h4>8. Other Content</h4>' +
            '<p>8.1 The Tagl.me Services may include hyperlinks to other web sites or content or resources or email content. Tagl.me may have no control over any web sites or resources which are provided by companies or persons other than Tagl.me.</p>' +
            '<p>8.2 You acknowledge and agree that Tagl.me is not responsible for the availability of any such external sites or resources, and does not endorse any advertising, products or other materials on or available from such web sites or resources.</p>' +
            '<p>8.3 You acknowledge and agree that Tagl.me is not liable for any loss or damage which may be incurred by you as a result of the availability of those external sites or resources, or as a result of any reliance placed by you on the completeness, accuracy or existence of any advertising, products or other materials on, or available from, such web sites or resources.</p>' +
            '<h4>9. Changes to the Terms</h4>' +
            '<p>9.1 Tagl.me may make changes to the Terms from time to time. If we change the Terms in any substantive way, we will give you a grace period of seven (7) days to reject the changes by terminating your account.</p>' +
            '<p>9.2 You understand and agree that if you use the Tagl.me Services after the date on which the Terms have changed, Tagl.me will treat your use as acceptance of the updated Terms.</p>' +
            '<h4>10. General Legal Terms</h4>' +
            '<p>10.1 The Terms constitute the whole legal agreement between you and Tagl.me and govern your use of the Tagl.me Services (but excluding any services which Tagl.me may provide to you under a separate written agreement), and completely replace any prior agreements between you and Tagl.me in relation to the Tagl.me Services.</p>' +
            '<p>10.2 If Tagl.me provides you with a translation of the English language version of these Terms, the English language version of these Terms will control if there is any conflict.</p>' +
            '<p>10.3 You agree that Tagl.me may provide you with notices, including those regarding changes to the Terms, by email, regular mail, or postings on the Tagl.me Services.</p>' +
            '<p>10.4 Tagl.me shall not be liable for failing or delaying performance of its obligations resulting from any condition beyond its reasonable control, including but not limited to, governmental action, acts of terrorism, earthquake, fire, flood or other acts of God, power failures, and Internet disturbances.</p>',

        // index page
        'FEATURES': 'Features',
        'USE_CASES': 'Use cases',
        'PRICING': 'Pricing',
        'RESOURCES': 'FAQ',
        'CONTACT': 'Contact',
        'DOCS': 'Docs',

        'ABOUT_PROJECT': 'About',
        'TERMS': 'Terms and conditions',
        'BY': 'by',

        'true': 'Yes',
        'false': 'No',
        'YES': 'Yes',
        'NO': 'No',
        'TAGLME_INDEX': 'https://tagl.me/en/index.html',
        'NFCPOINT_ABOUT': 'http://nfcpoint.ru',
        'TAGLME_ABOUT': 'https://tagl.me/en/about.html',
        'TAGLME_TERMS': 'https://tagl.me/en/terms.html',
        'TAGLME_CONTACT': 'https://tagl.me/en/contacts.html',
        'TAGLME_DOCS': 'https://docs.tagl.me',
        'MENU_HELP': 'Help',
        'TAGLME_FEEDBACK': 'https://tagl.me/en/feedback.html',
        'MENU_FEEDBACK': 'Feedback',

        'GROUP_NAME_PLACEHOLDER': 'Group name',
        'GROUP_DESCRIPTION_PLACEHOLDER': 'Group description',
        'DELETE_GROUP_CONFIRM_DIALOG_TITLE': 'Delete group',
        'DELETE_GROUP_CONFIRM_DIALOG_CONTENT': 'Are you sure to delete group with all configurations?',

        'URL_TYPE': 'URL link',
        'TEXT_TYPE': 'Plain text',
        'URI_TYPE': 'URI link',
        'VCARD_TYPE': 'Business card',
        'MIME_TYPE': 'Mime type',
        'PHONE_TYPE': 'Phone number',
        'GEO_TYPE': 'Geo location',
        'ANDROID_TYPE': 'Android package',
        'SMARTPOSTER_TYPE': 'Smart poster',

        'CONFIG_NAME': 'Configuration name',
        'CONFIG_TYPE': 'Type',
        'CONFIG_LOCK': 'Lock tag',
        'CONFIG_PASSWORD': 'Tag access password',
        'CONFIG_MANUFACTURER': 'Tag manufacturer',
        'CONFIG_MODEL': 'Tag model',
        'CONFIG_POWER_VALUE': 'Power value, 0-100%',
        'CONFIG_BROADCAST_RATE': 'Broadcast rate, ms',
        'CONFIG_PACKAGE_NAME': 'Package name',
        'CONFIG_PACKAGE_PLACEHOLDER': 'mobile.tagl.me',
        'CONFIG_ORDER': 'Order in group',
        'CONFIG_PACKAGE_NAME_PLACEHOLDER': 'mobile.tagl.me',
        'CONFIG_NAME_PLACEHOLDER': 'Tag on poster',
        'CONFIG_ORDER_PLACEHOLDER': '1',
        'CONFIG_PASSWORD_PLACEHOLDER': 'password',
        'CONFIG_MANUFACTURER_PLACEHOLDER': 'NFCpoint.ru',
        'CONFIG_MODEL_PLACEHOLDER': 'NFC Sticker NTAG213 round 25mm',
        'CONFIG_LATITUDE': 'Latitude',
        'CONFIG_LATITUDE_PLACEHOLDER': '34.312',
        'CONFIG_LONGITUDE': 'Longitude',
        'CONFIG_LONGITUDE_PLACEHOLDER': '-142.324',
        'CONFIG_PROXIMITY_NAME': 'Beacon name',
        'CONFIG_PROXIMITY_NAME_PLACEHOLDER': 'ShopBeacon',
        'CONFIG_UUID': 'UUID',
        'CONFIG_UUID_PLACEHOLDER': '550e8400-e29b-41d4-a716-446655440000',
        'CONFIG_MAJOR': 'Major',
        'CONFIG_MAJOR_PLACEHOLDER': '1',
        'CONFIG_MINOR': 'Minor',
        'CONFIG_MINOR_PLACEHOLDER': '1',
        'CONFIG_BROADCAST_RATE_PLACEHOLDER': '500',
        'CONFIG_MANUFACTURER_PLACEHOLDER_BEACON': 'Jaalee',
        'CONFIG_MODEL_PLACEHOLDER_BEACON': 'iB004N',
        'CONFIG_CONTENT_TYPE': 'mime type',
        'CONFIG_CONTENT_TYPE_PLACEHOLDER': 'text/plain',
        'CONFIG_CONTENT': 'Content',
        'CONFIG_CONTENT_PLACEHOLDER': 'Information',
        'CONFIG_PHONE': 'Phone number',
        'CONFIG_PHONE_PLACEHOLDER': '+1 844 632-8248',
        'CONFIG_TEXT': 'Text',
        'CONFIG_TEXT_PLACEHOLDER': 'Message',
        'CONFIG_URI': 'URI',
        'CONFIG_URI_PLACEHOLDER': 'wss://localhost:3000',
        'CONFIG_TITLE': 'Title',
        'CONFIG_TITLE_PLACEHOLDER': 'Poster',
        'CONFIG_URL': 'URL',
        'CONFIG_URL_PLACEHOLDER': 'http://example.com',
        'CONFIG_FIRST_NAME_VCARD': 'First name',
        'CONFIG_FIRST_NAME_VCARD_PLACEHOLDER': 'John',
        'CONFIG_LAST_NAME_VCARD': 'Last name',
        'CONFIG_LAST_NAME_VCARD_PLACEHOLDER': 'Doe',
        'CONFIG_ORGANIZATION_VCARD': 'Organization',
        'CONFIG_ORGANIZATION_VCARD_PLACEHOLDER': 'Bob Inc',
        'CONFIG_TITLE_VCARD': 'Title',
        'CONFIG_TITLE_VCARD_PLACEHOLDER': 'MFCEO',
        'CONFIG_EMAIL_VCARD': 'Email',
        'CONFIG_EMAIL_VCARD_PLACEHOLDER': 'bob@home.com',
        'CONFIG_HOME_PHONE_VCARD': 'Home phone',
        'CONFIG_HOME_PHONE_VCARD_PLACEHOLDER': '+1 844 632-8248',
        'CONFIG_WORK_PHONE_VCARD': 'Work phone',
        'CONFIG_WORK_PHONE_VCARD_PLACEHOLDER': '+1 844 632-8248',
        'CONFIG_CELL_PHONE_VCARD': 'Cell phone',
        'CONFIG_CELL_PHONE_VCARD_PLACEHOLDER': '+1 844 632-8248',
        'CONFIG_COUNTRY_VCARD': 'Country',
        'CONFIG_COUNTRY_VCARD_PLACEHOLDER': 'USA',
        'CONFIG_POSTAL_CODE_VCARD': 'Postal code',
        'CONFIG_POSTAL_CODE_VCARD_PLACEHOLDER': '123586',
        'CONFIG_REGION_VCARD': 'Region',
        'CONFIG_REGION_VCARD_PLACEHOLDER': 'WA',
        'CONFIG_CITY_VCARD': 'City',
        'CONFIG_CITY_VCARD_PLACEHOLDER': 'Seattle',
        'CONFIG_STREET_VCARD': 'Street',
        'CONFIG_STREET_VCARD_PLACEHOLDER': '3302 Fuhrman Ave E.',

        'DELETE_CONFIGS_CONFIRM_DIALOG_TITLE': 'Delete configurations',
        'DELETE_CONFIGS_CONFIRM_DIALOG_CONTENT': 'Are you sure to delete configurations?',
        'DELETE_CONFIG_CONFIRM_DIALOG_TITLE': 'Delete configuration',
        'DELETE_CONFIG_CONFIRM_DIALOG_CONTENT': 'Are you sure to delete configuration?',

        'EMPTY_GROUP': 'No configurations in group',
        'CONFIGS_COPIED': 'Configurations copied',
        'CONFIGS_PASTED': 'Configurations added',
        'CONFIGS_CREATE_FAILED': 'Failed to create configuration',
        'CONFIGS_UPDATE_FAILED': 'Failed to update configuration',
        'CONFIGS_REMOVE_FAILED': 'Failed to remove configuration',
        'CONFIGS_LOAD_FAILED': 'Failed to load configuration',

        'USER_ACCOUNT': 'User account',
        'USER_NAME': 'Username',

        'ACCOUNT_PASSWORD_CHANGE_FAILED': 'Failed to change password',
        'ACCOUNT_PASSWORD_CHANGED': 'Password changed. Please use new password to login.',
        'ACCOUNT_UPDATED': 'Account changed',
        'ACCOUNT_UPDATE_FAILED': 'Failed to change account',

        'CLOSE': 'Close',
        'ALL_RIGHTS_RESERVED': ' All rights reserved',
        'ACTIVATION_CODE_SENT': 'Activation code was send to your email',
        'EMAIL_ALREADY_REGISTERED': 'User already registered with this email',
        'USERNAME_ALREADY_REGISTERED': 'User already registered with this username',
        'RESET_CODE_SENT': 'Reset code was send to your email',
        'LOGIN_ERROR': 'Failed to login',
        'ACTIVATION_FAILED': 'Failed to activate account',
        'REGISTRATION_FINNISHED': 'Registration is finished, now you can login to account.',
        'FAILED_SENT_ACTIVATION': 'Failed to sent activation code',

        'CONFIG_QUANTITY': 'Encoding amount',
        'CONFIG_QUANTITY_PLACEHOLDER': '1'

    };

    // russian language
    var lang_ru = {
        'PLEASE_SIGN_IN': 'Пожалуйста войдите',
        'USERNAME_SIGN': 'Имя пользователя',
        'PASSWORD_SIGN': 'Пароль',
        'PASSWORD_NEW': 'Новый пароль',
        'REMEMBER_ME': 'Запомнить меня',
        'LOGIN': 'Войти',
        'SIGNUP': 'Регистрация',
        'USER_PROFILE': 'Мой профиль',
        'LOGOUT': 'Выйти',
        'EMAIL': 'E-mail',
        'CREATE_NEW_ACCOUNT': 'Создать новый аккаунт',
        'CONFIRM_PASSWORD': 'Подтвердить пароль',
        'PASSWORD_DID_NOT_MATCH': 'Ваши пароли не совпадают',
        'ENTER_ACTIVATION_CODE': 'Введите код активации',
        'ACTIVATE_CODE': 'Код активации',
        'FINISH_REGISTRATION': 'Закончить регистрацию',
        'RESET_PASSWORD': 'Востановления пароля',
        'SEND_RESET_CODE': 'Отправить код востановления пароля',
        'CONFIRM_RESET_PASSWORD': 'Востановить пароль',
        'SUBMIT_RESET_CODE': 'Принять',
        'FORGOT_PASSWORD': 'Забыли пароль?',
        'RESET_CODE': 'Код востановления',

        'USR_SETTINGS': 'Аккаунт',
        'USR_SETTINGS_HINT': 'Вы можете изменить некоторые настройки',
        'YOUR_LOGIN_NAME': 'Ваш логин',
        'EMAIL_ADDRESS': 'Электронная почта',
        'ACCOUNT_PLAN': 'План аккаунта',
        'SAVE': 'Сохранить',
        'CANCEL': 'Отменить',
        'RESET': 'Вернуть',
        'RETURN': 'Вернутьcя',
        'CHANGE_PASSWORD': 'Смена пароля',
        'CHANGE_PASSWORD_HINT': 'При желании сменить пароль укажите ваш текущий пароль и новый',
        'CURRENT_PASSWORD': 'Текущий пароль',
        'OLD_PASSWORD': 'Старый пароль',
        'NEW_PASSWORD': 'Новый пароль',
        'REPEAT_PASSWORD': 'Повторите новый пароль',
        'SAVE_PASSWORD': 'Сменить пароль',
        'ACTIVATION_HINT_MSG': 'Скопируйте сюда код активации что был выслан Вам на E-mail',
        'ASK_RESEND_ACTIVATION_EMAIL': 'Отправить email активации повторно?',
        'RESEND_ACTIVATION_EMAIL': 'Повторная отправка активации',
        'GO_BACK_TO_ACTIVATE_PAGE': 'Вернутся на страницу активации',
        'SUBMIT_SENDING': 'Отправить',
        'YOUR_PASSWORD_TOO_SHORT': 'Ваш пароль слишком короткий',
        'YOUR_PASSWORD_TOO_BIG': 'Ваш пароль слишком длинный',

        'ENCODINGS': 'Кодировки',
        'PREVIOUS': 'Предыдущая',
        'NEXT': 'Следующая',
        'FIRST': 'Первая',
        'LAST': 'Последняя',



        // sidebar
        'DASHBOARD': 'Dashboard',
        'DEPLOY': 'Deploy',

        // menu items
        'CREATE_NEW_NFC': 'New NFC encoding',
        'CREATE_NEW_BEACON': 'New Beacon encoding',

        // enc types:
        'T_NFC': 'NFC',
        'T_BEACON': 'Beacon',

        'ENCODING_TEMPLATES': 'Шаблоны кодирования',
        'CREATE': 'Создать',
        'ENCODING_LIST': 'Группы конфигураций',
        'DELETE': 'Удалить',
        'COPY': 'Копировать',
        'PASTE': 'Вставить',
        'SELECT_ALL': 'Выделить все',
        'MORE': 'Еще...',
        'ACTION': 'Действие',
        'EDIT': 'Редактировать',
        'EXPORT': 'Экспорт',
        'EXPORT_SELECTED': 'Экспорт выбранных',

        // create modal
        'CREATE_ENCODING': 'Добавить группу',
        'EDIT_ENCODING': 'Редактировать группу',
        'ENTER_ENCODING_NAME': 'Имя',
        'ENTER_ENCODING_DESCRIPTION': 'Описание',
        'SHOW': 'Показать',
        'NAME': 'Имя',
        'TYPE': 'Тип',
        'CONFIGS': 'Конфигурации',
        'CREATED_AT': 'Создано',
        'ACTIONS': 'Действия',

        // tagconfigs

        'EDIT_TAG_CONFIGS': 'Редактировать конфигурации группы',
        'CONFIGS_TEMPLATES': 'Шаблоны конфигураций',
        'CONFIGS_LIST': 'Конфигурации меток',
        'CREATE_CONFIG': 'Создать конфигурацию',
        'EDIT_CONFIG': 'Редактирование конфигурации',
        'OPTIONAL_FIELDS': 'Опции кодирования',
        'CONTENT_FIELDS': 'Содержание',
        'ORDER': 'Порядок',
        'CONTENT': 'Содержание',
        'LOCK': 'Блокировка',

        'PLAIN TEXT RECORD': 'Tекстовая запись',
        'TEXT': 'Текст',
        'URL': 'URL',
        'URI': 'URI',
        'PACKAGE NAME': 'Имя пакета',
        'URL RECORD': 'URL запись',
        'URL RECORD WITH "HTTP" OR "HTTPS" SCHEMA': 'Ссылка с "http" или "https" схемой',
        'URL RECORD WITH CUSTOM SCHEMA': 'URI запись',
        'ANDROID APPLICATION RECORD': 'Android-приложение запись',
        'BUSINESS CARD RECORD': 'Визитная карточка',
        'FIRST NAME': 'Имя',
        'LAST NAME': 'Фамилия',
        'ORGANIZATION': 'Организация',
        'JOB_TITLE': 'Должность',
        'HOME PHONE': 'Домашний телефон',
        'WORK PHONE': 'Рабочий телефон',
        'CELL PHONE': 'Мобильный телефон',
        'COUNTRY': 'Страна',
        'POSTAL CODE': 'Почтовый индекс',
        'REGION': 'Регион',
        'CITY': 'Город',
        'STREET': 'Улица',
        'CUSTOM MIME TYPE RECORD': 'MIME тип запись',
        'SMART POSTER RECORD': 'Смарт постер запись',
        'TITLE': 'Название',
        'GEO LOCATION RECORD': 'Гео расположение запись',
        'LATITUDE': 'Широта',
        'LONGITUDE': 'Долгота',
        'PHONE NUMBER RECORD': 'Телефон',
        'PHONE NUMBER': 'Телефон',
        'NAME OF NFC TAG CONFIGURATION': 'Имя конфигурации тега NFC',
        'ORDER OF CONFIGURATION IN ENCODING': 'Порядок конфигурации в группе',
        'LOCK NFC TAG DURING ENCODING': 'Блокировка NFC тега',
        'ACCESS PASSWORD TO NFC TAG': 'Пароль доступа к NFC метке',
        'MANUFACTURER OF NFC TAG': 'Производитель NFC метки',
        'MODEL OF NFC TAG': 'Модель NFC метки',
        'TEXT_CONFIG_PLACHOLDER': 'Сообщение',
        'MIME_CONTENT': 'Содержимое',
        'MIME_CONTENT_PLACHOLDER': 'Информация',
        'SMARTPOSTER_TITLE_PLACHOLDER': 'Постер',
        'VCARD_FIRST_NAME_PLACHOLDER': 'Виктор',
        'VCARD_LAST_NAME_PLACHOLDER': 'Иванов',
        'VCARD_ORGANIZATION_PLACHOLDER': 'Восток Сервис',
        'VCARD_TITLE_PLACHOLDER': 'Менеджер',
        'VCARD_EMAIL_PLACHOLDER': 'viktor@service.ru',
        'VCARD_PHONE_HOME_PLACHOLDER': '509-55-12',
        'VCARD_PHONE_WORK_PLACHOLDER': '509-55-12',
        'VCARD_PHONE_CELL_PLACHOLDER': '509-55-12',
        'VCARD_COUNTRY_PLACHOLDER': 'Россия',
        'VCARD_POSTAL_CODE_PLACHOLDER': '132154',
        'VCARD_REGION_PLACHOLDER': 'Тульская область',
        'VCARD_CITY_PLACHOLDER': 'Тула',
        'VCARD_STREET_PLACHOLDER': 'Проспект Ленина, 55',



        'IBEACON RECORD': 'iBeacon запись',
        'IBEACON_NAME': 'Имя',
        'PROXIMITY UUID': 'UUID',
        'MAJOR': 'Major',
        'MINOR': 'Minor',
        'URIBEACON RECORD': 'uriBeacon запись',
        'URIBEACON_NAME': 'Имя',
        'PROXIMITY URL': 'URL',

        'NAME OF BEACON TAG CONFIGURATION': 'Имя конфигурации тега Beacon',
        'ORDER OF CONFIGURATION ENCODING': 'Порядок конфигурации в группе',
        'BROADCASTING POWER LEVEL 0-100%': 'Мощность вещания, 0-100%',
        'BROADCASTING RATE IN MS': 'Частота вещания, мс',
        'ACCESS PASSWORD TO BEACON TAG': 'Пароль доступа к Beacon метке',
        'MANUFACTURER OF BEACON TAG': 'Производитель Beacon метки',
        'MODEL OF BEACON TAG': 'Модель Beacon метки',

        // breadcrumbs
        'BR_ENCODINGS': 'Encodings',
        'BR_ALL': 'Все',
        'BR_NFC': 'NFC',
        'BR_BEACON': 'Beacon',

        'MENU_NFC': 'Конфигурации',

        'I_AGREE_TO_THE_TERMS_AND_CONDITIONS': 'Я согласен с Условиями использования',

        'TERMS_AND_CONDITIONS_TITLE': 'Условия использования',
        'TERMS_AND_CONDITIONS_HTML': '<h5>Последнее обновление: 1 апреля 2016 года</h5>' +
            '<h4>1. Соглашение об использовании сервиса Tagl.me</h4>' +
            '<p>1.1 Использование сервиса Tagl.me регулируется этим соглашением (далее "Условия"). Термин "Услуги Tagl.me " означает услуги, которые Tagl.me делает доступными через данный сайт, в том числе и на этом сайте, службы облачных вычислений Tagl.me,  Tagl.me API, а также любое другое программное обеспечение или услуги, предлагаемые Tagl.me.</p>' +
            '<p>1.2 Для того, чтобы использовать Услуги Tagl.me, Вы должны сначала выразить свое согласие с Условиями. Вы можете согласиться с Условиями, начав пользоваться Услугами Tagl.me. Вы понимаете и соглашаетесь с тем, что Tagl.me будет рассматривать пользование Услугами Tagl.me как принятие Условий, с момента начала их использования.</p>' +
            '<p>1.3 Вы не можете использовать Услуги Tagl.me, если Вы являетесь лицом, которому запрещено получать Услуги Tagl.me в соответствии с законодательством Российской Федерации или других стран, в том числе страны, в которой Вы проживаете или из которой Вы используете Услуги Tagl.me. Вы подтверждаете, что Вы старше 16 лет, так как Услуги Tagl.me не предназначены для детей в возрасте до 16 лет.</p>' +
            '<p>1.4 Вы согласны с тем Ваши покупки Услуг Tagl.me делаются не из расчета возможности использования любых будущих функциональных возможностей или в зависимости от каких-либо устных или письменных публичных заявлений, сделанных Tagl.me или представителями Tagl.me в отношении будущих функциональных возможностей Услуг Tagl.me.</p>' +
            '<h4>2. Ваш Учетная запись и Использование Услуг Tagl.me</h4>' +
            '<p>2.1 Вы должны предоставить точную и полную информацию при регистрации, чтобы пользоваться Услугами Tagl.me. Вы несете ответственность за безопасность Ваших паролей и за любое использование Вашей учетной записи. Если вам стало известно о любом несанкционированном использовании Вашего пароля или аккаунта, Вы соглашаетесь немедленно уведомить об этом Tagl.me.</p>' +
            '<p>2.2 Использование Вами Услуг Tagl.me должны соблюдать все действующие законы, указы и постановления, в том числе любые законы, касающиеся экспорта данных или программного обеспечения.</p>' +
            '<p>2.3 Вы соглашаетесь (а) не пользоваться доступом (или делать попытки к доступу) к интерфейсу Услуг Tagl.me любым способом, кроме как через интерфейс, который обеспечивается Tagl.me, или (б) не участвовать в любой деятельности, которая препятствует или нарушает работу Услуг Tagl.me (или серверов и сетей, которые связаны с Услугами).</p>' +
            '<p>2.4 Ваша учетная запись имеет ограничения на использование. Услуги Tagl.me не разрешают Вам превышать пределы использования. Tagl.me оставляет за собой право применять ограничения на использование по своему усмотрению, что может привести к тому, что Вам будет продемонстрирована страница с сообщением о превышении предела использования. Многократное превышение ограничений на использование может привести к прекращению действия Вашего аккаунта.</p>' +
            '<h4>3. Плата за пользование Услугами Tagl.me</h4>' +
            '<p>3.1 В соответствии с Условиями, Услуги Tagl.me предоставляется Вам бесплатно в определенных пределах использования. Использование выше этого предела требует покупки дополнительных ресурсов или Услуг. Расценки на дополнительные ресурсы и Услуги можно найти на сайте по ссылке http://tagl.me/#pricing (или другой URL, который Tagl.me может предоставить).</p>' +
            '<p>3.2 Для всех купленных ресурсов и услуг, мы будем взимать плату с вашей кредитной карты ежемесячно или в интервале, указанном в тарифах Tagl.me. В полной мере, разрешенной законом, Вы отказываетесь от всех претензий в отношении платежей для покупки  Услуг Tagl.me, если эти претензии не переданы в Tagl.me в течение 60 дней после оплаты. Размер взымаемой платы рассчитывается исключительно на основе измерений Tagl.me по использования Вами Услуг Tagl.me, если иное не согласовано в письменной форме. В полной мере, разрешенной законом, возвраты по Услугам Tagl.me (если таковые имеются) осуществляются по усмотрению Tagl.me и только в виде кредита на использование Услуг Tagl.me. Ничто в настоящих Правилах не обязывает Tagl.me предоставлять кредит кому-либо на использование Услуг Tagl.me. Вы признаете и соглашаетесь, что любая кредитная карта и связанной с ней платежная информация, которую Вы предоставляете Tagl.me может быть передана компаниям, которые работают от имени Tagl.me (такие как платежные агрегаторы и / или кредитные организации), исключительно в целях осуществления платежа в Tagl.me и обслуживания Вашей учетной записи. Tagl.me также может предоставлять информацию в ответ на правомерные запросы от судебных и других органов власти. Tagl.me не несет ответственности за любое использование или раскрытие такой информации третьими сторонами. Tagl.me оставляет за собой право прекратить предоставление Вам Услуг Tagl.me за любые просроченные платежи.</p>' +
            '<p>3.3 Tagl.me может изменить свои сборы и правила оплаты за Услуги Tagl.me, уведомив вас по крайней мере за пятнадцать (15) дней до начала расчетного цикла, в котором такое изменение вступит в силу. Изменения в тарифах или политиках оплаты будет размещена на веб-сайте (или по другому адресу Tagl.me может предоставить время от времени). Любой непогашенный остаток становится немедленным к оплате после прекращения действия Условий по какой-либо причине.</p>' +
            '<h4>4. Контент на Tagl.me и Обязательства по его удалению</h4>' +
            '<p>4.1 Вы понимаете, что вся информация (например, файлы с данными, тексты, компьютерное программное обеспечение, музыку, звуковые файлы или другие звуки, фотографии, видео или другие изображения), к которым Вы можете иметь доступ как части, либо через использование Вами, Услуг Tagl.me являются исключительной ответственностью лица, от которого поступила эта информация. Вся такая информация будет именоваться далее как "Контент". Термин Контент исключает веб-приложение, которое Вы создаете, используя Услуги Tagl.me и любой исходный код, написанный вами, который будет использоваться с Услугами Tagl.me (далее "Приложения").</p>' +
            '<p>4.2 Tagl.me оставляет за собой право (но не берет на себя никаких обязательств), чтобы удалить любой или весь Контент из Услуг Tagl.me. Вы согласны с тем, чтобы немедленно удалить любые материалы, нарушающие политику использования, в том числе в соответствии с просьбой об удалении Контента от Tagl.me. В том случае, если Вы решили не выполнять просьбу Tagl.me об удалении Контента, Tagl.me оставляет за собой право удалить этот Контент.</p>' +
            '<p>4.3 Вы соглашаетесь, что Вы несете полную ответственность (и что Tagl.me не несет никакой ответственности перед Вами или любой третьей стороной) за любой Контент, который Вы создаете, передаете или демонстрируете при использовании Услуг Tagl.me и за последствия Ваших действий (включая любые убытки или ущерб, который может понести Tagl.me).</p>' +
            '<p>4.4 Вы согласны с тем, что Tagl.me не несет никакой ответственности или обязательств за удаление или невозможность хранения любого Контента и других сообщений, хранимых или передаваемых через использование Услуг Tagl.me. Кроме того, Вы признаете, что Вы несете полную ответственность за обеспечение безопасности и резервного копирования любого Контента.</p>' +
            '<h4>5. Внесение изменений и прекращение действия Услуг Tagl.me</h4>' +
            '<p>5.1 Tagl.me постоянно внедряет новые разработки для того, чтобы обеспечить наилучший опыт для своих пользователей. Вы признаете и соглашаетесь с тем, что форма и характер Услуг Tagl.me, который обеспечивает Tagl.me могут меняться время от времени без предварительного уведомления. Изменения в форме и характере Услуг Tagl.me будут касаться всех версий Услуг Tagl.me. Примеры изменений в форме и характеру Услуг Tagl.me включают (но не ограничивают) в себя изменения тарифов и политики платежей, обновления безопасности, дополнительные функции и другие усовершенствования.</p>' +
            '<p>5.2 Вы можете прекратить действие этих Условий в любое время, удалив свой аккаунт в Услугах Tagl.me. Вы не будете получать какие-либо возмещения за неиспользованные Услуги, если Вы удалите свой аккаунт.</p>' +
            '<p>5.3 Вы согласны с тем, что Tagl.me, по своему усмотрению и по любой причине или без нее, может прекратить действие Вашей учетной записи или любой его части. Вы согласны с тем, что любое прекращение Вашего доступа к Tagl.me служб могут быть без предварительного уведомления, и Вы соглашаетесь, что Tagl.me не будет нести ответственность перед Вами или любой третьей стороной за такое прекращение доступа.</p>' +
            '<p>5.4 Вы несете полную ответственность за экспорт Вашего контента из Услуг Tagl.me перед прекращением действия Вашей учетной записи по любой причине, при условии, что если доступ к Вашему аккаунту будет прекращен по инициативе Tagl.me, мы предоставим Вам разумную возможность для экспорта данных.</p>' +
            '<p>5.5 После любого прекращения действия Услуг Tagl.me или Вашей учетной записи действие этих Условий также будет прекращено, но разделы 5, 6, 7, 8, 9 Условий должны продолжать действовать.</p>' +
            '<h4>6. ИСКЛЮЧЕНИЕ ГАРАНТИЙ</h4>' +
            '<p>6.1 6.1 НИЧТО В УСЛОВИЯХ НЕ ИСКЛЮЧАЕТ И НЕ ОГРАНИЧИВАЕТ ГАРАНТИИ TAGL.ME, ИЛИ ОТВЕТСТВЕННОСТЬ, КОТОРЫЕ НЕ МОГУТ БЫТЬ ИСКЛЮЧЕНЫ ИЛИ ОГРАНИЧЕНЫ В СООТВЕТСТВИИ С ДЕЙСТВУЮЩИМ ЗАКОНОДАТЕЛЬСТВОМ.</p>' +
            '<p>6.2 ВЫ ПОНИМАЕТЕ И СОГЛАСНЫ С ТЕМ, ЧТО ИСПОЛЬЗУЕТЕ УСЛУГИ TAGL.ME НА СВОЙ СТРАХ И РИСК И ЧТО УСЛУГИ TAGL.ME ПРЕДОСТАВЛЯЮТСЯ  В ФОРМАТЕ "КАК ЕСТЬ" И "КАК ДОСТУПНО".</p>' +
            '<p>6.3 TAGL.ME И ЕГО ПРЕДСТАВИТЕЛИ НЕ ДЕЛАЮТ ГАРАНТИЙ И ОТКАЗЫВАЮТСЯ ОТ ВСЕХ ПОДРАЗУМЕВАЕМЫХ ГАРАНТИЙ В ОТНОШЕНИИ УСЛУГ TAGL.ME, ВКЛЮЧАЯ ПОДРАЗУМЕВАЕМЫЕ ГАРАНТИИ ПРИГОДНОСТИ ДЛЯ КОНКРЕТНЫХ ЦЕЛЕЙ. НЕ ОГРАНИЧИВАЯ ВЫШЕУПОМЯНУТОЕ, TAGL.ME И ЕГО ПРЕДСТАВИТЕЛИ НЕ ГАРАНТИРУЮТ ВАМ, ЧТО: (А) ИСПОЛЬЗОВАНИЕ ВАМИ УСЛУГ TAGL.ME БУДЕТ ОТВЕЧАТЬ ВАШИМ ТРЕБОВАНИЯМ, (B) ИСПОЛЬЗОВАНИЕ УСЛУГ TAGL.ME БУДЕТ НЕПРЕРЫВНО, БЕЗОПАСНО ИЛИ БЕЗ ВОЗНИКНОВЕНИЯ ОШИБОК, И (С) ДАННЫЕ ПРЕДОСТАВЛЯЕМЫЕ УСЛУГАМИ TAGL.ME БУДЕТ ТОЧНЫМЫ.</p>' +
            '<h4>7. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</h4>' +
            '<p>7.1 ВЫ ПОНИМАЕТЕ И СОГЛАШАЕТЕСЬ, ЧТО TAGL.ME И ЕГО ПРЕДСТАВИТЕЛИ НЕ НЕСУТ ОТВЕТСТВЕННОСТИ ПЕРЕД ВАМИ ЗА ПРЯМЫЕ ИЛИ КОСВЕННЫЕ УБЫТКИ, КОТОРЫЕ МОГУТ БЫТЬ ПОНЕСЕННЫ ВАМИ, ВНЕ ЗАВИСИМОСТИ ОТ ИХ ПРИЧИНЫ. ЭТО ВКЛЮЧАЕТ (НО НЕ ОГРАНИЧИВАЕТ) ЛЮБЫЕ ПОТЕРИ ПРИБЫЛИ (ПРИЧИННЕННЫЕ ПРЯМО ИЛИ КОСВЕННО), ПОТЕРЮ РЕПУТАЦИИ, ПОТЕРЮ ДАННЫХ, ЗАТРАТЫ НА ПРИОБРЕТЕНИЕ ТОВАРОВ ИЛИ УСЛУГ ДЛЯ ЗАМЕНЫ ИЛИ ДРУГИЕ НЕМАТЕРИАЛЬНЫЕ ПОТЕРИ.</p>' +
            '<p>7.2 ОГРАНИЧЕНИЯ ОТВЕТСТВЕННОСТИ TAGL.ME ПЕРЕД ВАМИ ВЫШЕ ПРИМЕНЯЮТСЯ В НЕЗАВИСИМОСТИ ОТ ТОГО БЫЛ ЛИ TAGL.ME ПРЕДУПРЕЖДЕН ИЛИ ДОЛЖЕН БЫЛ ЗНАТЬ О ВОЗМОЖНОСТИ ТАКОГО УЩЕРБА.</p>' +
            '<h4>8. Прочий Контент</h4>' +
            '<p>8.1 Услуги Tagl.me могут включать гиперссылки на другие веб-сайты, контент или ресурсы. Tagl.me может не иметь контроля над веб-сайтами или ресурсами, предоставляемые компаниями или лицами, не относящимися к Tagl.me.</p>' +
            '<p>8.2 Вы признаете и соглашаетесь с тем, что Tagl.me не несет ответственности за доступность любых таких внешних сайтов или ресурсов, и не поддерживает какую-либо рекламу, продукты или другие материалы, доступные на таких веб-сайтов или ресурсов.</p>' +
            '<p>8.3 Вы признаете и соглашаетесь с тем, что Tagl.me не несет ответственности за какие-либо убытки или ущерб, которые могут быть понесены Вами в результате наличия этих внешних сайтов или ресурсов, или в результате того, что Вы полагались на полноту, точность какой-либо рекламы, продуктов или других материалов, размещенных или доступных на таких веб-сайтах или ресурсах.</p>' +
            '<h4>9. Изменения Условий</h4>' +
            '<p>9.1 Tagl.me может вносить изменения в Условия время от времени. Если мы изменим условия каким-либо существенным образом, мы дадим Вам льготный период на срок семь (7) дней, чтобы отменить изменения Условий путем прекращения действия Вашей учетной записи.</p>' +
            '<p>9.2 Вы понимаете и соглашаетесь, что если Вы используете Услуги Tagl.me после даты внесения соответствующих изменений Условий, Tagl.me будет рассматривать этот факт как принятие обновленных Условий.</p>' +
            '<h4>10. Общие правовые условия</h4>' +
            '<p>10.1 Условия представляют собой юридическое соглашение между вами и Tagl.me и регулируют использование Услуг Tagl.me (за исключением услуг, которые Tagl.me могут предоставить Вам в соответствии с отдельным письменным соглашением), и полностью заменяют собой все предыдущие соглашения между Вами и Tagl.me по отношению к Услугам Tagl.me.</p>' +
            '<p>10.2 Если Tagl.me предоставляет Вам перевод английской версии настоящих Условий, версия на английском языке настоящих Условий будет приоритетной, в случае если есть не соответствия с переводом.</p>' +
            '<p>10.3 Вы согласны с тем, что Tagl.me может предоставить Вам уведомления, включая уведомления об изменениях Условий, по электронной почте, обычной почтой или путем размещения на Услугах Tagl.me. </p>' +
            '<p>10.4 Tagl.me не несет ответственности за задержку или невыполнение своих обязательств, вытекающих из каких-либо условий вне разумного контроля, включая, но не ограничиваясь: правительственные действия, террористические акты, землетрясения, пожары, наводнения или другие стихийные бедствия, сбои питания, а также сбои в работе Интернета.</p>',

        // index page
        'FEATURES': 'Особенности',
        'USE_CASES': 'Варианты использования',
        'PRICING': 'Цена',
        'RESOURCES': 'Вопросы',
        'CONTACT': 'Контакты',
        'DOCS': 'Документация',

        'ABOUT_PROJECT': 'О проекте',
        'TERMS': 'Условия использования',
        'BY': 'от',

        'true': 'Да',
        'false': 'Нет',
        'YES': 'Да',
        'NO': 'Нет',

        'TAGLME_INDEX': 'https://tagl.me/ru/index.html',
        'NFCPOINT_ABOUT': 'http://nfcpoint.ru',
        'TAGLME_ABOUT': 'https://tagl.me/ru/about.html',
        'TAGLME_TERMS': 'https://tagl.me/ru/terms.html',
        'TAGLME_CONTACT': 'https://tagl.me/ru/contacts.html',
        'TAGLME_DOCS': 'https://docs.tagl.me/ru/',
        'MENU_HELP': 'Справка',
        'TAGLME_FEEDBACK': 'https://tagl.me/ru/feedback.html',
        'MENU_FEEDBACK': 'Обратная связь',


        'GROUP_NAME_PLACEHOLDER': 'Имя группы',
        'GROUP_DESCRIPTION_PLACEHOLDER': 'Описание группы',
        'DELETE_GROUP_CONFIRM_DIALOG_TITLE': 'Удаление группы',
        'DELETE_GROUP_CONFIRM_DIALOG_CONTENT': 'Удалить группу со всеми конфигурациями?',
        'URL_TYPE': 'URL ссылка',
        'TEXT_TYPE': 'Простой текст',
        'URI_TYPE': 'URI ссылка',
        'VCARD_TYPE': 'Визитная карточка',
        'MIME_TYPE': 'Mime тип',
        'PHONE_TYPE': 'Телефон',
        'GEO_TYPE': 'Геолокация',
        'ANDROID_TYPE': 'Android приложение',
        'SMARTPOSTER_TYPE': 'Смарт постер',

        'CONFIG_NAME': 'Имя конфигурации',
        'CONFIG_TYPE': 'Тип',
        'CONFIG_LOCK': 'Блокировка метки',
        'CONFIG_PASSWORD': 'Пароль доступа к метке',
        'CONFIG_MANUFACTURER': 'Производитель метки',
        'CONFIG_MODEL': 'Модель метки',
        'CONFIG_POWER_VALUE': 'Мощность передачи, 0-100%',
        'CONFIG_BROADCAST_RATE': 'Частота передачи, мс',
        'CONFIG_PACKAGE_NAME': 'Имя приложения',
        'CONFIG_PACKAGE_PLACEHOLDER': 'mobile.tagl.me',
        'CONFIG_ORDER': 'Порядок в группе',
        'CONFIG_PACKAGE_NAME_PLACEHOLDER': 'mobile.tagl.me',
        'CONFIG_NAME_PLACEHOLDER': 'Метка на постере',
        'CONFIG_ORDER_PLACEHOLDER': '1',
        'CONFIG_PASSWORD_PLACEHOLDER': 'password',
        'CONFIG_MANUFACTURER_PLACEHOLDER': 'NFCpoint.ru',
        'CONFIG_MODEL_PLACEHOLDER': 'NFC наклейка NTAG213 круглая 25мм',
        'CONFIG_LATITUDE': 'Широта',
        'CONFIG_LATITUDE_PLACEHOLDER': '34.312',
        'CONFIG_LONGITUDE': 'Долгота',
        'CONFIG_LONGITUDE_PLACEHOLDER': '-142.324',
        'CONFIG_PROXIMITY_NAME': 'Имя маяка',
        'CONFIG_PROXIMITY_NAME_PLACEHOLDER': 'ShopBeacon',
        'CONFIG_UUID': 'UUID',
        'CONFIG_UUID_PLACEHOLDER': '550e8400-e29b-41d4-a716-446655440000',
        'CONFIG_MAJOR': 'Major',
        'CONFIG_MAJOR_PLACEHOLDER': '1',
        'CONFIG_MINOR': 'Minor',
        'CONFIG_MINOR_PLACEHOLDER': '1',
        'CONFIG_BROADCAST_RATE_PLACEHOLDER': '500',
        'CONFIG_MANUFACTURER_PLACEHOLDER_BEACON': 'Jaalee',
        'CONFIG_MODEL_PLACEHOLDER_BEACON': 'iB004N',
        'CONFIG_CONTENT_TYPE': 'Mime тип',
        'CONFIG_CONTENT_TYPE_PLACEHOLDER': 'text/plain',
        'CONFIG_CONTENT': 'Содержание',
        'CONFIG_CONTENT_PLACEHOLDER': 'Информация',
        'CONFIG_PHONE': 'Телефонный номер',
        'CONFIG_PHONE_PLACEHOLDER': '+7 499 231-2702',
        'CONFIG_TEXT': 'Текст',
        'CONFIG_TEXT_PLACEHOLDER': 'Сообщение',
        'CONFIG_URI': 'URI',
        'CONFIG_URI_PLACEHOLDER': 'wss://localhost:3000',
        'CONFIG_TITLE': 'Название',
        'CONFIG_TITLE_PLACEHOLDER': 'Постер',
        'CONFIG_URL': 'URL',
        'CONFIG_URL_PLACEHOLDER': 'http://example.com',
        'CONFIG_FIRST_NAME_VCARD': 'Имя',
        'CONFIG_FIRST_NAME_VCARD_PLACEHOLDER': 'Виктор',
        'CONFIG_LAST_NAME_VCARD': 'Фамилия',
        'CONFIG_LAST_NAME_VCARD_PLACEHOLDER': 'Иванов',
        'CONFIG_ORGANIZATION_VCARD': 'Организация',
        'CONFIG_ORGANIZATION_VCARD_PLACEHOLDER': 'Восток Сервис',
        'CONFIG_TITLE_VCARD': 'Должность',
        'CONFIG_TITLE_VCARD_PLACEHOLDER': 'Менеджер',
        'CONFIG_EMAIL_VCARD': 'Email',
        'CONFIG_EMAIL_VCARD_PLACEHOLDER': 'viktor@service.ru',
        'CONFIG_HOME_PHONE_VCARD': 'Домашний телефон',
        'CONFIG_HOME_PHONE_VCARD_PLACEHOLDER': '+7 499 231-2702',
        'CONFIG_WORK_PHONE_VCARD': 'Рабочий телефон',
        'CONFIG_WORK_PHONE_VCARD_PLACEHOLDER': '+7 499 231-2702',
        'CONFIG_CELL_PHONE_VCARD': 'Мобильный телефон',
        'CONFIG_CELL_PHONE_VCARD_PLACEHOLDER': '+7 499 231-2702',
        'CONFIG_COUNTRY_VCARD': 'Страна',
        'CONFIG_COUNTRY_VCARD_PLACEHOLDER': 'Россия',
        'CONFIG_POSTAL_CODE_VCARD': 'Почтовый индекс',
        'CONFIG_POSTAL_CODE_VCARD_PLACEHOLDER': '123586',
        'CONFIG_REGION_VCARD': 'Регион',
        'CONFIG_REGION_VCARD_PLACEHOLDER': 'Тульская область',
        'CONFIG_CITY_VCARD': 'Город',
        'CONFIG_CITY_VCARD_PLACEHOLDER': 'Тула',
        'CONFIG_STREET_VCARD': 'Адрес',
        'CONFIG_STREET_VCARD_PLACEHOLDER': 'Проспект Ленина, 55',

        'DELETE_CONFIGS_CONFIRM_DIALOG_TITLE': 'Удаление конфигураций',
        'DELETE_CONFIGS_CONFIRM_DIALOG_CONTENT': 'Удалить эти конфигурации?',
        'DELETE_CONFIG_CONFIRM_DIALOG_TITLE': 'Удаление конфигурации',
        'DELETE_CONFIG_CONFIRM_DIALOG_CONTENT': 'Удалить эту конфигурацию?',

        'EMPTY_GROUP': 'Нет конфигураций в группе',
        'CONFIGS_COPIED': 'Конфигурации скопированы',
        'CONFIGS_PASTED': 'Конфигурации добавлены',

        'CONFIGS_CREATE_FAILED': 'Ошибка создания конфигурации',
        'CONFIGS_UPDATE_FAILED': 'Ошибка обновления конфигурации',
        'CONFIGS_REMOVE_FAILED': 'Ошибка удаления конфигурации',
        'CONFIGS_LOAD_FAILED': 'Ошибка загрузки конфигурации',

        'USER_ACCOUNT': 'Аккаунт пользователя',
        'USER_NAME': 'Имя пользователя',

        'ACCOUNT_PASSWORD_CHANGE_FAILED': 'Ошибка изменения пароля',
        'ACCOUNT_PASSWORD_CHANGED': 'Пароль изменен. Используйте новый пароль для входа',
        'ACCOUNT_UPDATED': 'Аккаунт изменен',
        'ACCOUNT_UPDATE_FAILED': 'Ошибка изменения аккаунта',

        'CLOSE': 'Закрыть',
        'ALL_RIGHTS_RESERVED': ' Все права защищены',
        'ACTIVATION_CODE_SENT': 'Код активации отправлен на ваш email',
        'EMAIL_ALREADY_REGISTERED': 'Такой email уже зарегистрирован',
        'USERNAME_ALREADY_REGISTERED': 'Такое имя пользователя уже зарегистрировано',
        'RESET_CODE_SENT': 'Код сброса пароля отправлен на ваш email',
        'LOGIN_ERROR': 'Ошибка авторизации',
        'ACTIVATION_FAILED': 'Ошибка активации аккаунта',
        'REGISTRATION_FINNISHED': 'Регистрация завершена. Вы можете войти в ваш аккаунт',
        'FAILED_SENT_ACTIVATION': 'Ошибка отправки кода активации',


        'CONFIG_QUANTITY': 'Количество копий',
        'CONFIG_QUANTITY_PLACEHOLDER': '1',
    };

    var i18n = {
        'en': lang_en,
        'ru': lang_ru
    };

    // browser locale -> language
    var i18nLangKeys = {
        'en_US': 'en',
        'en_UK': 'en',
        'ru_RU': 'ru',
        'ru_UA': 'ru',
        'ua_UA': 'ru',
    };

    var languages = _.keys(i18n),
        defaultLanguage = languages[0];

    angular
        .module('taglme')
        .constant('I18N', i18n)
        .constant('I18N_DEFAULT_LANGUAGE', defaultLanguage)
        .constant('I18N_LANGUAGE_KEYS', i18nLangKeys)
        .constant('LANGUAGES', languages);
})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .config(configTranslate);

  /** @ngInject */
  function configTranslate($translateProvider, I18N, LANGUAGES, I18N_DEFAULT_LANGUAGE, I18N_LANGUAGE_KEYS) {
    _.each(I18N, function(set, language) {
      $translateProvider.translations(language, set);
    });

//    $translateProvider.preferredLanguage(I18N_DEFAULT_LANGUAGE);
    $translateProvider.useLocalStorage();
    $translateProvider.determinePreferredLanguage();
    $translateProvider.registerAvailableLanguageKeys(LANGUAGES, I18N_LANGUAGE_KEYS)
    $translateProvider.fallbackLanguage(I18N_DEFAULT_LANGUAGE);
  }

})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('ResendActivationEmailController', ResendActivationEmailController);

    /** @ngInject */
    function ResendActivationEmailController($stateParams, $state, LoginAuth, errorHandler, toastr, $translate) {
        var vm = this;

        vm.email = $stateParams.email;

        var gotoActivatePage = function(entety) {
            $state.go('activateUser');
            return entety;
        };

        var message = function(entety) {
            toastr.success($translate.instant('ACTIVATION_CODE_SENT'));
            return entety;
        };

        vm.doResend = function(email) {
            return LoginAuth.resendActivateEmail(email)
                .then(message)
                .then(gotoActivatePage)
                .catch(errorHandler($translate.instant('FAILED_SENT_ACTIVATION')));
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .factory('errorCheck', errorCheck)
        .service('toastrInfo', toastrInfo)
        .service('errorHandler', errorHandler);

    /** @ngInject
     *
     * uaa service return 200 always, so need check result. Use it in thenable
     * */
    function errorCheck($q) {
        return function(result) {
            if (result.error) {
                return $q.reject(result);
            } else {
                return $q.resolve(result);
            }
        };
    }

    /** @ngInject
     *
     * This handler may be used in catch to show 'toastr' error
     * Usage
     *
     * api.some().then(errorCheck).catch(errorHandler('some default error text));
     *
     * */
    function errorHandler($q, toastr, $log) {
        return function(defaultText) {
            return function(entety) {

                var msg = defaultText;
                $log.debug('Error entety', entety);

                if (entety && entety.error_description) {
                    msg = entety.error_description;
                } else if (entety && entety.status) { // maybe "entety" is response object, try inspect it
                    if (entety.data) {
                        var data = entety.data;
                        if (_.isString(data)) {
                            msg = data;
                            // TODO: data.error is constant (ex. "access_denied"), NEED INTERNATIONALIZING message
                        } else if (data && data.error_message ||
                            data.error_description ||
                            data.error_info) {
                            msg = data.error_message ||
                                data.error_description ||
                                data.error_info;
                        }
                    } else if (entety.statusText) {
                        msg = entety.statusText;
                    }
                } else if (_.isString(entety)) {
                    msg = entety;
                }

                toastr.error(msg);
                return entety;
            };
        };
    }

    /** @ngInject
     *
     *  Create promise for  showing toastr
     * .then(toastrInfo('hello'))
     */
    function toastrInfo($q, toastr) {
        return function(message) {
            return function(entety) {
                toastr.info(message);
                $q.resolve(entety);
            };
        };
    }

})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .service('currentUser', currentUser)
    .service('tokenStorage', tokenStorage)
    .service('UAA', uaaResource)
    .service('LoginAuth', LoginAuth);

  /**
   * @ngInject
   *
   * getter/setter of current user profile data
   */
  function currentUser($rootScope) {
    var user;

    return {
      set: function(me) {
        user = me;
        $rootScope.$broadcast('user:updated', user);
      },
      get: function() {
        return user;
      },
    };
  }

  /** @ngInject
   *
   * Token storage, used localStorage, but may be cookie used instead.
   * */
  function tokenStorage() {
    // keys:
    var REMEMBER_ME = 'remember',
        USER_ACC_TOK = 'userTok',
        REFRESH_TOK = 'refeshUserTok';

    var isRememberMe = function() {
      var v = localStorage.getItem(REMEMBER_ME);
      return v === 'yes';
    };

    var setRememberMe = function(rememberMe) {
      localStorage.setItem(REMEMBER_ME, rememberMe ? 'yes' : 'no');
      return this;
    };

    // if rememberMe on - use localStorage
    var getStorage = function() {
      var storage = sessionStorage;
      if (isRememberMe()) {
        storage = localStorage;
      }
      return storage;
    };

    return {
      isRememberMe: isRememberMe,
      setRememberMe: setRememberMe,

      clear: function() {
        var storage = getStorage();

        storage.removeItem(USER_ACC_TOK);
        storage.removeItem(REFRESH_TOK);
      },
      userToken: function(token) {
        var storage = getStorage();
        if (! _.isUndefined(token)) {
          storage.setItem(USER_ACC_TOK, token);
          return this;
        } else {
          return storage.getItem(USER_ACC_TOK);
        }
      },
      refreshToken: function(token) {
        var storage = getStorage();
        if (! _.isUndefined(token)) {
          storage.setItem(REFRESH_TOK, token);
          return this;
        } else {
          return storage.getItem(REFRESH_TOK);
        }
      }
    };
  }

    /** @ngInject */
  function uaaResource($resource, APIURL, currentUser, $http, $q) {
    var tokenResource = $resource(APIURL + '/oauth/token', {}, {
      getUserToken: {
        method: 'POST',
        params: {
          grant_type: 'password'
        },
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      },
      refreshUserToken: {
        method: 'POST',
        params: {
          grant_type: 'refresh_token'
        },
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      },
    });

    var userResource = $resource(APIURL + '/oauth/account', {}, {
      'update': { method:'PUT' }
    });

    function signUp(username, password, email) {
      var params = {
        name: username,
        password: password,
        email: email
      };
      var signUpResource = $resource(APIURL + '/oauth/forms/signup');

      return signUpResource.save(params).$promise;
    }

    function activateUser(code) {
      var activationResource = $resource(APIURL + '/oauth/forms/activation/activate');

      return activationResource.save({activation_code: code}).$promise;
    }

    function sendResetPasswordEmail(email) {
      var resetPasswordResource = $resource(APIURL + '/oauth/forms/password/send');
      return resetPasswordResource.save({user_account: email}).$promise;
    }

    function resendActivateEmail(email) {
      var resendEmailResource = $resource(APIURL + '/oauth/forms/activation/send');
      return resendEmailResource.save({user_account: email}).$promise;
    }

    function resetPasswordCode(code, newPas) {
      var resetResource = $resource(APIURL + '/oauth/forms/password/reset');
      var params = {
        reset_code: code,
        new_password: newPas
      };

      return resetResource.save(params).$promise;
    }

    function invalidateToken(token) {
      return $http.post(APIURL + '/oauth/invalidate_token?token=' + token);
    }

    function changePasswrod(oldPas, newPas) {
      var userPasswordResource = $resource(APIURL + '/oauth/account/password/change');
      var params = {
        old_password: oldPas,
        new_password: newPas,
      };

      return userPasswordResource.save(params).$promise;
    }

    function getMe() {

      return userResource.get().$promise.then(function(me) {
        // save current user
        currentUser.set(me);
        return me;
      });
    }

    function updateMe(entety) {
      var me = currentUser.get();
      if (me) {
        var updateDate = _.assign(me, entety);

        return userResource.update(updateDate).$promise;
      }
      return $q.reject();
    }

    return {
      getUserToken: tokenResource.getUserToken,
      refreshUserToken: tokenResource.refreshUserToken,
//      user: userResource,
      getMe: getMe,
      changePasswrod: changePasswrod,
      updateMe: updateMe,
      signUp: signUp,
      activateUser: activateUser,
      sendResetPasswordEmail: sendResetPasswordEmail,
      resetPasswordCode: resetPasswordCode,
      resendActivateEmail: resendActivateEmail,
      invalidateToken: invalidateToken,
    };
  }

  /** @ngInject */
  function LoginAuth(UAA, tokenStorage, currentUser, errorCheck, $timeout, $q, $rootScope) {
    var saveUserToken = function(rememberMeFlag) {
      return function(authResponse) {
        tokenStorage
          .setRememberMe(!!rememberMeFlag) // setting storage first
          .userToken(authResponse.access_token)
          .refreshToken(authResponse.refresh_token);
        return $q.resolve(authResponse);
      };
    };

    var authSuccessBroadcast = function(authResponse) {
      $rootScope.$broadcast('authorized');
      return authResponse;
    };

    var uaa = {
      login: function(username, password, rememberMeFlag) {
        var params = $.param({
          username: username,
          password: password,
        });

        return UAA.getUserToken(params).$promise
          .then(errorCheck)
          .then(saveUserToken(rememberMeFlag))
          .then(UAA.getMe)
          .then(authSuccessBroadcast);
      },

      logout: function() {
        var currentToken = tokenStorage.userToken();
        if (currentToken) {
          UAA.invalidateToken(currentToken);
        }

        tokenStorage.clear();
        currentUser.set(null);

        return $q.resolve();
      },

      signup: function(username, password, email) {
        return UAA.signUp(username, password, email)
          .then(errorCheck);
      },

      activate: function(code) {
        return UAA.activateUser(code)
          .then(errorCheck);
      },

      resetPassword: function(email) {
        return UAA.sendResetPasswordEmail(email)
          .then(errorCheck);
      },

      confirmResetPassword: function(code, newPassword) {
        return UAA.resetPasswordCode(code, newPassword)
          .then(errorCheck);
      },

      resendActivateEmail: UAA.resendActivateEmail,
    };

    return uaa;
  }

})();

(function() {
  'use strict';

  angular
    .module('taglme')
    .service('EncodingsService', EncodingsService);

  /** @ngInject */
  function EncodingsService(APIURL, $http, $resource) {
    var encRes = $resource(APIURL + '/deploy/encodings/:id', {}, {
      'update':  {method:'PUT'},
    });

    return {
      create: function(name, description, type) {
        var params = {
          name: name,
          description: description,
          type: type
        };
        return encRes.save(params).$promise;
      },

      query: function(limit, offset, type) {
        var TYPES = {
          nfc: 'nfc',
          beacon: 'beacon',
          nfcTag: 'nfc',
        };

        var params = {
          limit: limit,
          offset: offset,
          type: TYPES[type],
        };
        return encRes.get(params).$promise;
      },

      getEncoder: function(id) {
        return encRes.get({id: id}).$promise;
      },

      remove: function(id) {
        return encRes.remove({id: id}).$promise;
      },

      update: function(id, name, description, type) {
        var params = {
          name: name,
          description: description,
          type: type
        };

        return encRes.update({id: id}, params).$promise;
      },
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('taglme')
    .filter('e2Icon', typeToIcon)
    .filter('e2Name', typeToName);

  /** @ngInject */
  function typeToIcon() {
    var types = {
      nfcTag: 'fa-tag',
      beacon: 'fa-wifi',
    };
    return function(type) {
      return types[type];
    };
  }

  /** @ngInject */
  function typeToName($translate) {
    var types = {};
    $translate(['T_NFC', 'T_BEACON']).then(function(t) {
      types = {
        'nfcTag': t.T_NFC,
        'beacon': t.T_BEACON
      };
    });

    return function(type) {
      return types[type];
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('EncodingsController', EncodingsController);

    /** @ngInject */
    function EncodingsController($scope, $translate, encodeItemModal, EncodingsService, $log, $q, $stateParams,
        TagConfigService, TagConfigExport,
        errorHandler, toastr, eachSeries) {
        var vm = this;
        var LC_LIMIT_KEY = 'table_limit',
            DEFAULT_LIMIT = 10;

        vm.encodersTypes = [
            'nfcTag',
            'beacon'
        ];

        vm.selected = {}; // id -> boolean
        vm.encodings = [];

        vm.showCreateModal = function(type) {
            encodeItemModal.create().then(function(data) {
                var name = data.name,
                    description = data.description;
                EncodingsService.create(name, description, type)
                    .catch(errorHandler('Cannot create encoding'))
                    .finally(populateTable);
            });
        };

        vm.limit = localStorage.getItem(LC_LIMIT_KEY) || DEFAULT_LIMIT;
        // set items per page. save in storage
        vm.setLimit = function(newLimit) {
            localStorage.setItem(LC_LIMIT_KEY, newLimit);
            vm.limit = newLimit;
            vm.page = 1;
            populateTable();
        };
        vm.offset = 0;
        vm.page = 1;

        vm.loadingTable = false; // once for populating table
        vm.updating = false; // set true before some api call and populate table

        populateTable();

        $scope.$watch('enc.page', populateTable);

        // populating table will remove selected items
        function populateTable() {
            vm.selected = {};
            vm.copied = [];

            if (vm.loadingTable) {
                return;
            }
            console.log($stateParams.filter);
            var filterBy = vm.filterBy = $stateParams.filter,
                limit = vm.limit,
                page = vm.page - 1, // paginator start from 1
                offset = page * limit;

            var applyLoadedData = function(res) {
                vm.encodings = res.items;
                vm.total = res.total;
            };

            vm.loadingTable = true;
            EncodingsService.query(limit, offset, filterBy)
                .then(applyLoadedData)
                .finally(function() {
                    vm.loadingTable = false;
                    vm.updating = false;
                });
        }

        vm.isLoading = function() {
            return vm.loadingTable || vm.updating;
        };

        vm.tglSelection = function(encode) {
            var id = encode.id;
            vm.selected[id] = !vm.selected[id];
        };

        function getSelection() {
            var selected = vm.selected;
            var ids = _.keys(selected);

            return _.filter(ids, function(id) {
                return selected[id];
            });
        }

        vm.deleteSelected = function() {
            var selected = getSelection();


            if (selected.length && confirm('Do you really want remove selected items?')) {
                vm.updating = true;
                eachSeries(selected, function(id) {
                    return EncodingsService.remove(id).catch(errorHandler('Fail to remove ' + id));
                }).finally(populateTable);
            }

        };

        vm.copyEncodings = function() {
            var selectedIds = getSelection(),
                encodings = vm.encodings;

            if (selectedIds.length) {
                var selected = _.map(selectedIds, function(id) {
                    return _.clone(_.findWhere(encodings, { id: id }));
                });
                vm.copied = selected;
                toastr.info('Copied ' + selectedIds.length + ' items');
            }
        };

        vm.pasteEncodings = function() {
            var copied = vm.copied;

            vm.updating = true;
            eachSeries(copied, function(item) {
                var name = item.name,
                    description = item.description || '',
                    type = item.type;
                return EncodingsService.create(name, description, type).catch(errorHandler('Fail to copy item'));
            }).finally(populateTable);
        };

        vm.selectAll = function() {
            vm.selected = {};
            _.each(vm.encodings, function(enc) {
                var id = enc.id;
                vm.selected[id] = true;
            });
        };

        vm.edit = function(encoding) {
            if (_.isObject(encoding)) {
                var name = encoding.name,
                    id = encoding.id,
                    type = encoding.type,
                    description = encoding.description;

                encodeItemModal
                    .edit(name, description)
                    .then(function(modalRes) {
                        var newName = modalRes.name,
                            newDesc = modalRes.description;

                        EncodingsService.update(id, newName, newDesc, type)
                            .catch(errorHandler('Cannot update encoding'))
                            .finally(populateTable);
                    });
            }
        };
        /*
                vm.deleteItem = function(id) {
                    if (id && confirm($translate.instant('DELETE_GROUP_CONFIRM_DIALOG_CONTENT'))) {
                        EncodingsService.remove(id)
                            .catch(errorHandler('Fail to remove ' + id))
                            .finally(populateTable);
                    }
                };
        */
        vm.deleteItem = function(id) {
            if (id) {
                encodeItemModal.delete().then(function() {
                    EncodingsService.remove(id)
                        .catch(errorHandler('Fail to remove ' + id))
                        .finally(populateTable);
                });

            }
        };



        vm.exportItemHeaders = ['Id', 'Type', 'Name', 'Description'];

        vm.exportSelected = function() {
            var selectedIds = getSelection(),
                encodings = vm.encodings;

            var encodingsId = _.map(selectedIds, function(id) {
                var enc = _.findWhere(encodings, { id: id });
                return enc.id;
            });

            var items = [];

            // collect and export
            eachSeries(encodingsId, addTagConfigs2Items).then(exportItems);

            function addTagConfigs2Items(id) {
                return collectTagConfigs(id).then(function(tagconfigs) {
                    items = items.concat(tagconfigs);
                });
            }

            function exportItems() {
                TagConfigExport.export(items);
            }
        };

        vm.exportItem = function(encoding) {
            var encodingId = encoding.id;

            collectTagConfigs(encodingId).then(exportItems);

            function exportItems(items) {
                TagConfigExport.export(items);
            }
        };

        // get ALL tagconfigs, using loop with limit 50 each time
        function collectTagConfigs(encodingId) {
            var deferred = $q.defer(),
                limit = 50, // each query limit
                total,
                items = []; // resolve(items)

            function nextTagConfigs() {
                var offset = items.length;
                return TagConfigService.query(encodingId, limit, offset).
                then(function(entety) {
                    total = entety.total;
                    var entetyItems = entety.items;
                    items = items.concat(entetyItems);

                    if (total > items.length) {
                        return nextTagConfigs();
                    } else {
                        return deferred.resolve(items);
                    }
                }).catch(function() {
                    deferred.reject();
                });
            }
            nextTagConfigs();
            return deferred.promise;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($timeout, $translate, toastr, currentUser, UAA, LoginAuth, $state, errorHandler) {
        var vm = this;

        function populateModel() {
            return UAA.getMe()
                .then(function(me) {
                    vm.name = me.name;
                    vm.email = me.email;
                    vm.plan = me.plan;
                });
        }

        populateModel();

        vm.reset = populateModel;

        vm.changePassword = function() {
            var goToLoginPage = function() { $state.go('login'); };

            var msgPasswordChanged = function() {
                toastr.info($translate.instant('ACCOUNT_PASSWORD_CHANGED'));
            };

            var oldPas = vm.oldPassword,
                newPas = vm.newPassword;

            UAA.changePasswrod(oldPas, newPas)
                .then(LoginAuth.logout)
                .then(goToLoginPage)
                .then(msgPasswordChanged)
                .catch(errorHandler($translate.instant('ACCOUNT_PASSWORD_CHANGE_FAILED')));
        };

        vm.updateProfile = function() {
            var newMe = {
                name: vm.name,
                email: vm.email
            };

            UAA.updateMe(newMe)
                .then(UAA.getMe)
                .then(function() {
                    toastr.success($translate.instant('ACCOUNT_UPDATED'));
                })
                .catch(errorHandler($translate.instant('ACCOUNT_UPDATE_FAILED')));
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('SignUpController', SignUpController);

    /** @ngInject */
    function SignUpController($scope, LoginAuth, errorHandler, toastr, $state, $translate) {
        var vm = this;

        vm.doSignUp = function(username, password, email) {

            var showMsg = function(entety) {
                toastr.info($translate.instant('ACTIVATION_CODE_SENT'));
                return entety;
            };

            var gotoActivatePage = function(authResponse) {
                $state.go('activateUser', { email: email });
                return authResponse;
            };

            LoginAuth.signup(username, password, email)
                .then(showMsg)
                .then(gotoActivatePage)
                .catch(function(err) {
                    // expected errors:
                    // err = {data: {"error_message": 'user with id 359652ac-c61a-49e8-5d2b-e90f6acaa645 already exists'}};
                    // err = {data: {"error_message": 'user with email TEST@TEST already exists'}};

                    var reson = err && err.data && err.data.error_message;

                    if (reson && reson.match(/user with email.*exists/)) {
                        toastr.error($translate.instant('EMAIL_ALREADY_REGISTERED'));
                        //            gotoActivatePage();
                    } else if (reson && reson.match(/user with id.*exists/)) {
                        vm.badUsername = true; // highlight input
                        return toastr.info($translate.instant('USERNAME_ALREADY_REGISTERED'));
                    } else {
                        return errorHandler($translate.instant('USERNAME_ALREADY_REGISTERED'))(err);
                    }
                });
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(LoginAuth, $state, errorHandler, toastrInfo, $translate) {
        var vm = this;

        vm.sendReset = function(email) {
            LoginAuth.resetPassword(email)
                .then(function() {
                    $state.go('confirmResetPassword');
                })
                .then(toastrInfo($translate.instant('RESET_CODE_SENT')))
                .catch(errorHandler($translate.instant('ACCOUNT_PASSWORD_CHANGE_FAILED')));

        };
    }
})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($translate, $rootScope, $scope, $http, $sce) {
    var vm = this;

    translatePage();

    var destroyListener = $rootScope.$on('$translateChangeSuccess', translatePage);

    $scope.$on('$destroy', function () {
      destroyListener();        // clear
    });

    function translatePage() {
        var currentLanguage = $translate.use();
        vm.landingPage = '/landing_' + currentLanguage + '.html';
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(LoginAuth, $timeout, toastr, currentUser, $state, errorHandler, tokenStorage, $translate) {
        var vm = this;

        vm.rememberme = !!tokenStorage.isRememberMe();

        vm.doLogin = function() {
            var username = vm.username,
                password = vm.password,
                rememberme = !!vm.rememberme;

            LoginAuth.login(username, password, rememberme)
                .then(function() {
                    var user = currentUser.get(),
                        username = user.name;
                    var locale = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                    if (locale == 'ru') {
                        toastr.success('Здравствуйте, ' + username);
                    } else {
                        toastr.success('Wellcome, ' + username);
                    }

                    $state.go('app.encodings', { filter: 'nfcTag' });
                })
                .catch(function() {
                    toastr.error($translate.instant('LOGIN_ERROR'));
                });
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .controller('ActivateUserController', ActivateUserController);

    /** @ngInject */
    function ActivateUserController(LoginAuth, errorHandler, $state, $stateParams, toastr, $translate) {
        var vm = this;

        var code = vm.code = $stateParams.activateCode;

        vm.email = $stateParams.email;

        var actErrHandler = errorHandler($translate.instant('ACTIVATION_FAILED'));

        function activate(code) {
            return LoginAuth.activate(code)
                .then(function() {
                    $state.go('login');
                    toastr.success($translate.instant('REGISTRATION_FINNISHED'));
                });
        }

        if (code) {
            activate(code)
                .catch(actErrHandler);
        }

        vm.doActivate = function(code) {
            activate(code).catch(actErrHandler);
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('taglme')
    .controller('SidebarController', SidebarController);

  /** @ngInject */
  function SidebarController() {

  }
})();

/* ------------------------------------------------------------------------------
 *
 *  # Template JS core
 *
 *  Core JS file with default functionality configuration
 *
 *  Version: 1.2
 *  Latest update: Dec 11, 2015
 *
 * ---------------------------------------------------------------------------- */


// Allow CSS transitions when page is loaded
$(window).on('load', function() {
    $('body').removeClass('no-transitions');
});


$(function() {

    // Disable CSS transitions on page load
    $('body').addClass('no-transitions');



    // ========================================
    //
    // Content area height
    //
    // ========================================


    // Calculate min height
    /*
    function containerHeight() {
        console.log($(".page-content").height());
        var availableHeight = $(window).height() - $('.page-container').offset().top - $('.navbar-fixed-bottom').outerHeight();

        $('.page-container').attr('style', 'min-height:' + availableHeight + 'px');
    }

    // Initialize
    containerHeight();
*/



    // ========================================
    //
    // Heading elements
    //
    // ========================================


    // Heading elements toggler
    // -------------------------

    // Add control button toggler to page and panel headers if have heading elements
    $('.panel-footer').has('> .heading-elements:not(.not-collapsible)').prepend('<a class="heading-elements-toggle"><i class="icon-more"></i></a>');
    $('.page-title, .panel-title').parent().has('> .heading-elements:not(.not-collapsible)').children('.page-title, .panel-title').append('<a class="heading-elements-toggle"><i class="icon-more"></i></a>');


    // Toggle visible state of heading elements
    $('.page-title .heading-elements-toggle, .panel-title .heading-elements-toggle').on('click', function() {
        $(this).parent().parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements');
    });
    $('.panel-footer .heading-elements-toggle').on('click', function() {
        $(this).parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements');
    });



    // Breadcrumb elements toggler
    // -------------------------

    // Add control button toggler to breadcrumbs if has elements
    $('.breadcrumb-line').has('.breadcrumb-elements').prepend('<a class="breadcrumb-elements-toggle"><i class="icon-menu-open"></i></a>');


    // Toggle visible state of breadcrumb elements
    $('.breadcrumb-elements-toggle').on('click', function() {
        $(this).parent().children('.breadcrumb-elements').toggleClass('visible-elements');
    });




    // ========================================
    //
    // Navbar
    //
    // ========================================


    // Navbar navigation
    // -------------------------

    // Prevent dropdown from closing on click
    $(document).on('click', '.dropdown-content', function(e) {
        e.stopPropagation();
    });

    // Disabled links
    $('.navbar-nav .disabled a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // Show tabs inside dropdowns
    $('.dropdown-content a[data-toggle="tab"]').on('click', function(e) {
        $(this).tab('show');
    });




    // ========================================
    //
    // Element controls
    //
    // ========================================


    // Reload elements
    // -------------------------

    // Panels
    $('.panel [data-action=reload]').click(function(e) {
        e.preventDefault();
        var block = $(this).parent().parent().parent().parent().parent();
        $(block).block({
            message: '<i class="icon-spinner2 spinner"></i>',
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
            }
        });

        // For demo purposes
        window.setTimeout(function() {
            $(block).unblock();
        }, 2000);
    });


    // Sidebar categories
    $('.category-title [data-action=reload]').click(function(e) {
        e.preventDefault();
        var block = $(this).parent().parent().parent().parent();
        $(block).block({
            message: '<i class="icon-spinner2 spinner"></i>',
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.5,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #000'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none',
                color: '#fff'
            }
        });

        // For demo purposes
        window.setTimeout(function() {
            $(block).unblock();
        }, 2000);
    });


    // Light sidebar categories
    $('.sidebar-default .category-title [data-action=reload]').click(function(e) {
        e.preventDefault();
        var block = $(this).parent().parent().parent().parent();
        $(block).block({
            message: '<i class="icon-spinner2 spinner"></i>',
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait',
                'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
            }
        });

        // For demo purposes
        window.setTimeout(function() {
            $(block).unblock();
        }, 2000);
    });



    // Collapse elements
    // -------------------------

    //
    // Sidebar categories
    //

    // Hide if collapsed by default
    $('.category-collapsed').children('.category-content').hide();


    // Rotate icon if collapsed by default
    $('.category-collapsed').find('[data-action=collapse]').addClass('rotate-180');


    // Collapse on click
    $('.category-title [data-action=collapse]').click(function(e) {
        e.preventDefault();
        var $categoryCollapse = $(this).parent().parent().parent().nextAll();
        $(this).parents('.category-title').toggleClass('category-collapsed');
        $(this).toggleClass('rotate-180');

        containerHeight(); // adjust page height

        $categoryCollapse.slideToggle(150);
    });


    //
    // Panels
    //

    // Hide if collapsed by default
    $('.panel-collapsed').children('.panel-heading').nextAll().hide();


    // Rotate icon if collapsed by default
    $('.panel-collapsed').find('[data-action=collapse]').addClass('rotate-180');


    // Collapse on click
    $('.panel [data-action=collapse]').click(function(e) {
        e.preventDefault();
        var $panelCollapse = $(this).parent().parent().parent().parent().nextAll();
        $(this).parents('.panel').toggleClass('panel-collapsed');
        $(this).toggleClass('rotate-180');

        containerHeight(); // recalculate page height

        $panelCollapse.slideToggle(150);
    });



    // Remove elements
    // -------------------------

    // Panels
    $('.panel [data-action=close]').click(function(e) {
        e.preventDefault();
        var $panelClose = $(this).parent().parent().parent().parent().parent();

        containerHeight(); // recalculate page height

        $panelClose.slideUp(150, function() {
            $(this).remove();
        });
    });


    // Sidebar categories
    $('.category-title [data-action=close]').click(function(e) {
        e.preventDefault();
        var $categoryClose = $(this).parent().parent().parent().parent();

        containerHeight(); // recalculate page height

        $categoryClose.slideUp(150, function() {
            $(this).remove();
        });
    });




    // ========================================
    //
    // Main navigation
    //
    // ========================================


    // Main navigation
    // -------------------------

    // Add 'active' class to parent list item in all levels
    $('.navigation').find('li.active').parents('li').addClass('active');

    // Hide all nested lists
    $('.navigation').find('li').not('.active, .category-title').has('ul').children('ul').addClass('hidden-ul');

    // Highlight children links
    $('.navigation').find('li').has('ul').children('a').addClass('has-ul');

    // Add active state to all dropdown parent levels
    $('.dropdown-menu:not(.dropdown-content), .dropdown-menu:not(.dropdown-content) .dropdown-submenu').has('li.active').addClass('active').parents('.navbar-nav .dropdown:not(.language-switch), .navbar-nav .dropup:not(.language-switch)').addClass('active');



    // Main navigation tooltips positioning
    // -------------------------

    // Left sidebar
    // $('.navigation-main > .navigation-header > i').tooltip({
    //     placement: 'right',
    //     container: 'body'
    // });



    // Collapsible functionality
    // -------------------------

    // Main navigation
    $('.navigation-main').find('li').has('ul').children('a').on('click', function(e) {
        e.preventDefault();

        // Collapsible
        $(this).parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).toggleClass('active').children('ul').slideToggle(250);

        // Accordion
        if ($('.navigation-main').hasClass('navigation-accordion')) {
            $(this).parent('li').not('.disabled').not($('.sidebar-xs').not('.sidebar-xs-indicator').find('.navigation-main').children('li')).siblings(':has(.has-ul)').removeClass('active').children('ul').slideUp(250);
        }
    });


    // Alternate navigation
    $('.navigation-alt').find('li').has('ul').children('a').on('click', function(e) {
        e.preventDefault();

        // Collapsible
        $(this).parent('li').not('.disabled').toggleClass('active').children('ul').slideToggle(200);

        // Accordion
        if ($('.navigation-alt').hasClass('navigation-accordion')) {
            $(this).parent('li').not('.disabled').siblings(':has(.has-ul)').removeClass('active').children('ul').slideUp(200);
        }
    });




    // ========================================
    //
    // Sidebars
    //
    // ========================================


    // Mini sidebar
    // -------------------------

    // Toggle mini sidebar
    $('.sidebar-main-toggle').on('click', function(e) {
        e.preventDefault();

        // Toggle min sidebar class
        $('body').toggleClass('sidebar-xs');
    });



    // Sidebar controls
    // -------------------------

    // Disable click in disabled navigation items
    $(document).on('click', '.navigation .disabled a', function(e) {
        e.preventDefault();
    });


    // Adjust page height on sidebar control button click
    $(document).on('click', '.sidebar-control', function(e) {
        containerHeight();
    });


    // Hide main sidebar in Dual Sidebar
    $(document).on('click', '.sidebar-main-hide', function(e) {
        e.preventDefault();
        $('body').toggleClass('sidebar-main-hidden');
    });


    // Toggle second sidebar in Dual Sidebar
    $(document).on('click', '.sidebar-secondary-hide', function(e) {
        e.preventDefault();
        $('body').toggleClass('sidebar-secondary-hidden');
    });


    // Hide all sidebars
    $(document).on('click', '.sidebar-all-hide', function(e) {
        e.preventDefault();

        $('body').toggleClass('sidebar-all-hidden');
    });



    //
    // Opposite sidebar
    //

    // Collapse main sidebar if opposite sidebar is visible
    $(document).on('click', '.sidebar-opposite-toggle', function(e) {
        e.preventDefault();

        // Opposite sidebar visibility
        $('body').toggleClass('sidebar-opposite-visible');

        // If visible
        if ($('body').hasClass('sidebar-opposite-visible')) {

            // Make main sidebar mini
            $('body').addClass('sidebar-xs');

            // Hide children lists
            $('.navigation-main').children('li').children('ul').css('display', '');
        } else {

            // Make main sidebar default
            $('body').removeClass('sidebar-xs');
        }
    });


    // Hide main sidebar if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-main-hide', function(e) {
        e.preventDefault();

        // Opposite sidebar visibility
        $('body').toggleClass('sidebar-opposite-visible');

        // If visible
        if ($('body').hasClass('sidebar-opposite-visible')) {

            // Hide main sidebar
            $('body').addClass('sidebar-main-hidden');
        } else {

            // Show main sidebar
            $('body').removeClass('sidebar-main-hidden');
        }
    });


    // Hide secondary sidebar if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-secondary-hide', function(e) {
        e.preventDefault();

        // Opposite sidebar visibility
        $('body').toggleClass('sidebar-opposite-visible');

        // If visible
        if ($('body').hasClass('sidebar-opposite-visible')) {

            // Hide secondary
            $('body').addClass('sidebar-secondary-hidden');

        } else {

            // Show secondary
            $('body').removeClass('sidebar-secondary-hidden');
        }
    });


    // Hide all sidebars if opposite sidebar is shown
    $(document).on('click', '.sidebar-opposite-hide', function(e) {
        e.preventDefault();

        // Toggle sidebars visibility
        $('body').toggleClass('sidebar-all-hidden');

        // If hidden
        if ($('body').hasClass('sidebar-all-hidden')) {

            // Show opposite
            $('body').addClass('sidebar-opposite-visible');

            // Hide children lists
            $('.navigation-main').children('li').children('ul').css('display', '');
        } else {

            // Hide opposite
            $('body').removeClass('sidebar-opposite-visible');
        }
    });


    // Keep the width of the main sidebar if opposite sidebar is visible
    $(document).on('click', '.sidebar-opposite-fix', function(e) {
        e.preventDefault();

        // Toggle opposite sidebar visibility
        $('body').toggleClass('sidebar-opposite-visible');
    });



    // Mobile sidebar controls
    // -------------------------

    // Toggle main sidebar
    $('.sidebar-mobile-main-toggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-main').removeClass('sidebar-mobile-secondary sidebar-mobile-opposite');
    });


    // Toggle secondary sidebar
    $('.sidebar-mobile-secondary-toggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-secondary').removeClass('sidebar-mobile-main sidebar-mobile-opposite');
    });


    // Toggle opposite sidebar
    $('.sidebar-mobile-opposite-toggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('sidebar-mobile-opposite').removeClass('sidebar-mobile-main sidebar-mobile-secondary');
    });



    // Mobile sidebar setup
    // -------------------------

    $(window).on('resize', function() {
        setTimeout(function() {
            //containerHeight();

            if ($(window).width() <= 768) {

                // Add mini sidebar indicator
                $('body').addClass('sidebar-xs-indicator');

                // Place right sidebar before content
                $('.sidebar-opposite').prependTo('.page-content');

                // Add mouse events for dropdown submenus
                $('.dropdown-submenu').on('mouseenter', function() {
                    $(this).children('.dropdown-menu').addClass('show');
                }).on('mouseleave', function() {
                    $(this).children('.dropdown-menu').removeClass('show');
                });
            } else {

                // Remove mini sidebar indicator
                $('body').removeClass('sidebar-xs-indicator');

                // Revert back right sidebar
                $('.sidebar-opposite').insertAfter('.content-wrapper');

                // Remove all mobile sidebar classes
                $('body').removeClass('sidebar-mobile-main sidebar-mobile-secondary sidebar-mobile-opposite');

                // Remove visibility of heading elements on desktop
                $('.page-header-content, .panel-heading, .panel-footer').removeClass('has-visible-elements');
                $('.heading-elements').removeClass('visible-elements');

                // Disable appearance of dropdown submenus
                $('.dropdown-submenu').children('.dropdown-menu').removeClass('show');
            }
        }, 100);
    }).resize();




    // ========================================
    //
    // Other code
    //
    // ========================================


    // Plugins
    // -------------------------

    // Popover
    // $('[data-popup="popover"]').popover();


    // Tooltip
    // $('[data-popup="tooltip"]').tooltip();

});
(function() {
    'use strict';

    angular
        .module('taglme')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, UAA, tokenStorage, errorCheck, errorHandler, authService, $state) {

        UAA.getMe(); // populate user data

        // catch 401 event, maybe refresh token
        $rootScope.$on('event:auth-loginRequired', function(event, data) {
            $log.debug("Get new event");
            $log.debug("Event:" + event);
            $log.debug("Data:" + data);
            $log.debug("Current state:" + $state.current);
            if (!$state.current.protected) {
                if ($state.current.name == "login") {
                    var promise = new Promise(function(resolve, reject) {
                        reject(data.data.error_message)
                    });
                    promise.catch(errorHandler(data.data.error_message));
                    authService.loginCancelled();
                }

            } else if ($state.current.protected == true && data.data.error_info != "Token is not active") {
                authService.loginCancelled();
                $state.go('login');

            } else {

                var refreshToken = tokenStorage.refreshToken(),
                    param = $.param({
                        refresh_token: refreshToken
                    });

                var saveTokens = function(authResponse) {
                    $log.debug('Save token');
                    tokenStorage
                        .userToken(authResponse.access_token)
                        .refreshToken(authResponse.refresh_token);
                    return authResponse;
                };
                var applyDefered401HttpRequest = function(entety) {
                    // retry 401 http buffers (see http-auth-interceptor)
                    authService.loginConfirmed();
                    return entety;
                };

                $log.debug('Refreshing token');
                $log.debug(tokenStorage.refreshToken());

                UAA.refreshUserToken(param).$promise
                    .then(errorCheck) // api send 200, even failed!
                    .then(saveTokens)
                    .then(applyDefered401HttpRequest)
                    .catch(function() {
                        $log.debug('Refreshing token catch');
                        // cancel all 401 requests
                        authService.loginCancelled();

                        // does this page require authorization?
                        var currentState = $state.current;
                        if (currentState.protected) {
                            $state.go('login');
                        }
                    });


            }



        });

        $log.debug('runBlock end');
    }

})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/main/main.html',
                onEnter: function($state) {
                    $state.go('app.encodings', { filter: 'nfcTag' });
                }
            })
            .state('userSettings', {
                url: '/profile',
                templateUrl: 'app/userSettings/profile.html',
                controller: 'ProfileController',
                controllerAs: 'profile',
                appNavBar: true, //  appNavBar - use encodings navbar, otherwise index navbar
                protected: true // authorize field - required authorization
            })
            .state('activateUser', {
                url: '/activate/:activateCode',
                templateUrl: 'app/activate/activate.html',
                controller: 'ActivateUserController',
                controllerAs: 'activate',
                params: {
                    email: null,
                }
            })
            .state('resendActivationEmail', {
                url: '/send-again-email/',
                templateUrl: 'app/activate/resend/resend.html',
                controller: 'ResendActivationEmailController',
                controllerAs: 'resend',
                params: {
                    email: null,
                }
            })
            .state('signup', {
                url: '/signup',
                templateUrl: 'app/signup/signup.html',
                controller: 'SignUpController',
                controllerAs: 'signup'
            })
            .state('resetPassword', {
                url: '/reset',
                templateUrl: 'app/password/reset.html',
                controller: 'ResetPasswordController',
                controllerAs: 'reset'
            })
            .state('confirmResetPassword', {
                url: '/reset/confirm/:activateCode',
                templateUrl: 'app/password/reset/confirm.html',
                controller: 'ConfigrmResetPasswordController',
                controllerAs: 'confirm'
            })
            .state('login', {
                url: '/login',
                templateUrl: 'app/login/login.html',
                controller: 'LoginController',
                controllerAs: 'login'
            })

        .state('app', {
                templateUrl: 'app/app/sidebar.html',
                controller: 'SidebarController',
                controllerAs: 'sidebar',
            })
            .state('app.encodings', {
                url: '/encodings/:filter',
                templateUrl: 'app/app/encoding/encoding.html',
                controller: 'EncodingsController',
                controllerAs: 'enc',
                protected: true,
                appNavBar: true,
            })
            .state('app.tagconfig', {
                'url': '/encoding/:id/tagconfigs',
                'templateUrl': 'app/app/encoding/tagconfig/tagconfig.html',
                controller: 'TagConfigController',
                controllerAs: 'tagcfg',
                protected: true,
                appNavBar: true,
            })

        .state('app.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/app/dashboard/dashboard.html',
                protected: true,
                appNavBar: true,
            })
            .state('app.deploy', {
                url: '/deploy',
                templateUrl: 'app/app/deploy/deploy.html',
                protected: true,
                appNavBar: true,
            })

        .state('terms', {
            url: '/terms',
            templateUrl: 'app/terms/terms.html'
        });

        $urlRouterProvider.otherwise('/');
    }

})();
/* global malarkey:false, moment:false */
(function() {
    'use strict';

    angular
        .module('taglme')
        .constant('malarkey', malarkey)
        .constant('APIURL', '')
        .constant('moment', moment);

})();
(function() {
    'use strict';

    angular
        .module('taglme')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig, $httpProvider, $locationProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = false;
        toastrConfig.progressBar = true;

        $httpProvider.interceptors.push('TokenInterceptor');
        $httpProvider.interceptors.push('LangInterceptor');
        $locationProvider.html5Mode(true);
    }

})();
angular.module("taglme").run(["$templateCache", function($templateCache) {$templateCache.put("app/activate/activate.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form ng-submit=\"activate.doActivate(activate.code)\"><div class=\"text-center\"><div class=\"icon-object border-success text-success\"><i class=\"fa fa-check icon-round\"></i></div><h4 class=\"content-group\">{{\'ENTER_ACTIVATION_CODE\' | translate }}</h4></div><div class=\"form-group\"><input class=\"form-control\" name=\"activatecode\" autocomplete=\"off\" required=\"\" ng-model=\"activate.code\" placeholder=\"{{ \'ACTIVATE_CODE\' | translate }}\"></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" value=\"{{\'FINISH_REGISTRATION\' | translate }}\"><p class=\"help-block\" align=\"left\"><a href=\"#\" ui-sref=\"resendActivationEmail({email: activate.email})\">{{\'ASK_RESEND_ACTIVATION_EMAIL\' | translate}}</a></p></div></form></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/app/sidebar.html","<div><div class=\"page-container\"><div class=\"page-content\"><div class=\"sidebar sidebar-main sidebar-default\"><div class=\"sidebar-content\"><div class=\"sidebar-category sidebar-category-visible\"><div class=\"category-content no-padding\"><ul class=\"navigation navigation-main navigation-accordion\"><li class=\"no-decor\"><a ui-sref=\"app.encodings({filter: \'nfcTag\'})\" ui-sref-active=\"text-grn\" class=\"pl-40\" translate=\"\">MENU_NFC</a></li></ul></div></div></div></div><div class=\"content-wrapper\"><main ui-view=\"\"></main></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/login/login.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form ng-submit=\"login.doLogin()\"><div class=\"text-center\"><div class=\"icon-object border-primary text-primary\"><i class=\"fa fa-user icon-round\"></i></div><h4 class=\"content-group\">{{\'PLEASE_SIGN_IN\' | translate }}</h4></div><fieldset><div class=\"form-group\"><input class=\"form-control\" name=\"username\" ng-model=\"login.username\" placeholder=\"{{ \'EMAIL\' | translate }}\" required=\"\"></div><div class=\"form-group\"><input class=\"form-control\" name=\"password\" ng-model=\"login.password\" placeholder=\"{{ \'PASSWORD_SIGN\' | translate }}\" type=\"password\" required=\"\"></div><div class=\"checkbox\" align=\"left\"><label><input id=\"remember\" name=\"remember\" type=\"checkbox\" ng-model=\"login.rememberme\" value=\"1\"> {{ \'REMEMBER_ME\' | translate }}</label></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" value=\"{{\'LOGIN\' | translate }}\"><p class=\"help-block\" align=\"left\"><a ui-sref=\"resetPassword\">{{\'FORGOT_PASSWORD\' | translate}}</a></p></div></fieldset></form></div><div class=\"text-center\"><h4><a class=\"text-center\" ui-sref=\"signup\" translate=\"\">CREATE_NEW_ACCOUNT</a></h4></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/main/main.html","<ng-include src=\"main.landingPage\"></ng-include>");
$templateCache.put("app/password/reset.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form ng-submit=\"reset.sendReset(email)\"><div class=\"text-center\"><div class=\"icon-object border-warning text-warning\"><i class=\"fa fa-refresh icon-round\"></i></div><h4 class=\"content-group\">{{\'RESET_PASSWORD\' | translate }}</h4></div><fieldset><div class=\"form-group\"><input class=\"form-control\" name=\"email\" type=\"email\" required=\"\" ng-model=\"email\" placeholder=\"{{ \'EMAIL\' | translate }}\"></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" value=\"{{\'SEND_RESET_CODE\' | translate }}\"></div></fieldset></form></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/signup/signup.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form name=\"singupFm\" role=\"form\" ng-submit=\"signup.doSignUp(username, password, email)\"><div class=\"text-center\"><div class=\"icon-object border-success text-success\"><i class=\"fa fa-user-plus icon-round\"></i></div><h4 class=\"content-group\" translate=\"\">CREATE_NEW_ACCOUNT</h4></div><fieldset><input type=\"text\" style=\"display:none\"> <input type=\"password\" style=\"display:none\"><div class=\"form-group\" ng-class=\"{ \'has-error\': signup.badUsername }\"><input class=\"form-control\" name=\"username\" ng-model=\"username\" placeholder=\"{{\'USERNAME_SIGN\' | translate}}\" ng-change=\"signup.badUsername=false\" required=\"\" minlength=\"2\" maxlength=\"32\" type=\"text\"></div><div class=\"form-group\"><input class=\"form-control\" name=\"email\" ng-model=\"email\" placeholder=\"{{\'EMAIL\' | translate}}\" type=\"email\" required=\"\" autofocus=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': singupFm.password.$error.minlength || singupFm.password.$error.maxlength }\"><input class=\"form-control\" name=\"password\" ng-model=\"password\" placeholder=\"{{\'PASSWORD_SIGN\' | translate}}\" required=\"\" type=\"password\" ng-minlength=\"4\" ng-maxlength=\"54\" value=\"\"><div class=\"clearfix\"><div ng-messages=\"singupFm.password.$error\"><div ng-message=\"minlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_SHORT\' | translate}}</div><div ng-message=\"maxlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_BIG\' | translate}}</div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': singupFm.confirmPassword.$error.passwordMatch }\"><input class=\"form-control\" match-password=\"password\" ng-model=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'CONFIRM_PASSWORD\' | translate}}\" type=\"password\" value=\"\"><div class=\"clearfix\"><div ng-messages=\"singupFm.confirmPassword.$error\"><div ng-message=\"passwordMatch\" class=\"control-label\">{{\'PASSWORD_DID_NOT_MATCH\' | translate}}</div></div></div></div><div class=\"checkbox\" align=\"left\"><label><input name=\"terms\" type=\"checkbox\" ng-model=\"agree\"> <a href=\"{{\'TAGLME_TERMS\' | translate }}\" target=\"_blank\" translate=\"\">I_AGREE_TO_THE_TERMS_AND_CONDITIONS</a></label></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" ng-disabled=\"singupFm.$invalid || !singupFm.$dirty || !agree\" value=\"{{\'SIGNUP\' | translate}}\"></div></fieldset></form></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/terms/terms.html","<div class=\"row\"><div class=\"container\"><h1 translate=\"\">TERMS_AND_CONDITIONS_TITLE</h1><div ng-bind-html=\"\'TERMS_AND_CONDITIONS_HTML\' | translate\"></div></div></div>");
$templateCache.put("app/userSettings/profile.html","<div class=\"page-container\"><div class=\"page-content\"><div class=\"sidebar sidebar-main sidebar-default\"><div class=\"sidebar-content\"><div class=\"sidebar-category sidebar-category-visible\"><div class=\"category-content no-padding\"><ul class=\"navigation navigation-main navigation-accordion\"><li class=\"no-decor\"><a ui-sref=\"app.encodings({filter: \'\'})\" ui-sref-active=\"text-grn\" translate=\"\" class=\"pl-40\">RETURN</a></li></ul></div></div></div></div><div class=\"content-wrapper\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"panel panel-flat\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><h4 class=\"no-margin-top h-grey\" translate=\"\">USER_ACCOUNT</h4><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-md-4 text-right h-grey\" translate=\"\">USER_NAME</label><div class=\"col-md-8\"><div class=\"form-control-static\">{{profile.name}}</div></div></div><div class=\"form-group\"><label class=\"control-label col-md-4 text-right h-grey\" translate=\"\">EMAIL</label><div class=\"col-md-8\"><div class=\"form-control-static\">{{profile.email}}</div></div></div><div class=\"form-group\"><label class=\"control-label col-md-4 text-right h-grey\" translate=\"\">ACCOUNT_PLAN</label><div class=\"col-md-8\"><div class=\"form-control-static\">{{profile.plan}}</div></div></div></form><h4 translate=\"\" class=\"h-grey\">CHANGE_PASSWORD</h4><form class=\"form-horizontal\" name=\"changePwdFm\" ng-submit=\"profile.changePassword()\"><input type=\"text\" style=\"display:none\"> <input type=\"password\" style=\"display:none\"><div class=\"form-group\"><label class=\"control-label col-md-4 text-right h-grey\" for=\"oldpass\" translate=\"\">CURRENT_PASSWORD</label><div class=\"col-md-8\"><input type=\"password\" id=\"oldpass\" class=\"form-control\" required=\"\" ng-model=\"profile.oldPassword\" placeholder=\"{{\'OLD_PASSWORD\' | translate}}\"></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': changePwdFm.newPassword.$error.minlength || changePwdFm.newPassword.$error.maxlength}\"><label for=\"newpass\" class=\"control-label col-md-4 text-right h-grey\" translate=\"\">NEW_PASSWORD</label><div class=\"col-md-8\"><input name=\"newPassword\" type=\"password\" class=\"form-control\" id=\"newpass\" required=\"\" ng-model=\"profile.newPassword\" ng-minlength=\"4\" ng-maxlength=\"54\" placeholder=\"{{\'NEW_PASSWORD\' | translate}}\"><div class=\"clearfix\"><div ng-messages=\"changePwdFm.newPassword.$error\"><div ng-message=\"minlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_SHORT\' | translate}}</div><div ng-message=\"maxlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_BIG\' | translate}}</div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': changePwdFm.confirmPassword.$error.passwordMatch }\"><label class=\"control-label col-md-4 text-right h-grey\" for=\"confpass\" translate=\"\">REPEAT_PASSWORD</label><div class=\"col-md-8\"><input name=\"confirmPassword\" type=\"password\" class=\"form-control\" id=\"confpass\" required=\"\" ng-model=\"profile.confirmPassword\" match-password=\"newPassword\" placeholder=\"{{\'REPEAT_PASSWORD\' | translate}}\"><div class=\"clearfix\"><div ng-messages=\"changePwdFm.confirmPassword.$error.passwordMatch\"><div ng-message=\"passwordMatch\" class=\"control-label\">{{\'PASSWORD_DID_NOT_MATCH\' | translate }}</div></div></div></div></div><div class=\"text-right\"><button type=\"submit\" ng-disabled=\"changePwdFm.$invalid || !changePwdFm.$dirty\" class=\"btn btn-grn\" translate=\"\">SAVE_PASSWORD</button></div></form></div></div></div></div></div></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/activate/resend/resend.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form ng-submit=\"resend.doResend(resend.email)\"><div class=\"text-center\"><div class=\"icon-object border-info text-info\"><i class=\"fa fa-refresh icon-round\"></i></div><h4 class=\"content-group\" translate=\"\">RESEND_ACTIVATION_EMAIL</h4></div><fieldset><div class=\"form-group\"><input class=\"form-control\" name=\"email\" type=\"email\" required=\"\" ng-model=\"resend.email\" placeholder=\"{{ \'EMAIL\' | translate }}\"></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" value=\"{{\'SUBMIT_SENDING\' | translate }}\"><p class=\"help-block\" align=\"left\"><a href=\"#\" ui-sref=\"activateUser\" translate=\"\">GO_BACK_TO_ACTIVATE_PAGE</a></p></div></fieldset></form></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/app/dashboard/dashboard.html","<h1>Dashboard</h1>");
$templateCache.put("app/app/deploy/deploy.html","<h1>Deploy</h1>");
$templateCache.put("app/app/encoding/encoding.html","<div class=\"col-sm-12\"><h4 class=\"h-grey\" translate=\"\">ENCODING_LIST</h4></div><fieldset class=\"col-sm-12 toolbar-padding\" ng-disabled=\"enc.isLoading()\"><button type=\"button\" class=\"btn btn-orange\" ng-click=\"enc.showCreateModal(\'nfcTag\')\">{{\'CREATE\' | translate }}</button><div class=\"btn-group pull-right\" dropdown=\"\" keyboard-nav=\"\"><button id=\"simple-btn-keyboard-nav\" type=\"button\" class=\"btn btn-default\" dropdown-toggle=\"\">{{\'SHOW\' | translate}} {{enc.limit}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"limit in [10, 20, 50]\"><a ng-click=\"enc.setLimit(limit)\" href=\"#\" role=\"menuitem\" tabindex=\"-1\">{{limit}}</a></li></ul></div></fieldset><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th translate=\"\">NAME</th><th class=\"center-align\" translate=\"\">CONFIGS</th><th translate=\"\">CREATED_AT</th><th translate=\"\">ACTIONS</th></tr></thead><tbody><tr ng-repeat=\"encode in enc.encodings\" ng-class=\"{\'selected-row\': enc.selected[encode.id]}\"><td class=\"mPointer vcenter-align\" ui-sref=\"app.tagconfig({id: encode.id})\">{{ encode.name }}</td><td class=\"mPointer vcenter-align center-align\" ui-sref=\"app.tagconfig({id: encode.id})\">{{encode.configs.total}}</td><td class=\"mPointer vcenter-align\" ui-sref=\"app.tagconfig({id: encode.id})\">{{ encode.created | date : \'dd/MM/yy HH:mm:ss\' }}</td><td class=\"vcenter-align\"><div class=\"btn-group\" dropdown=\"\" keyboard-nav=\"\"><button type=\"button\" class=\"btn btn-default btn-sm\" dropdown-toggle=\"\">{{\'ACTION\' | translate }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"#\" ng-click=\"enc.edit(encode)\"><i class=\"fa fa-fw fa-pencil\"></i> {{\'EDIT\' | translate}}</a></li><li><a href=\"#\" ng-click=\"enc.exportItem(encode)\"><i class=\"fa fa-fw fa-download\"></i> {{\'EXPORT\' | translate}}</a></li><li><a href=\"#\" ng-click=\"enc.deleteItem(encode.id)\"><i class=\"fa fa-fw fa-trash-o\"></i> {{\'DELETE\' | translate}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td></td><td colspan=\"7\"><pagination ng-disabled=\"enc.isLoading()\" total-items=\"enc.total\" ng-model=\"enc.page\" items-per-page=\"enc.limit\" previous-text=\"{{\'PREVIOUS\' | translate}}\" next-text=\"{{\'NEXT\' | translate}}\" first-text=\"{{\'FIRST\' | translate}}\" last-text=\"{{\'LAST\' | translate}}\" max-size=\"10\" class=\"pagination-sm\" boundary-links=\"true\"></pagination></td></tr></tfoot></table></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"navbar navbar-default navbar-fixed-bottom footer\"><ul class=\"nav navbar-nav visible-xs-block\"><li><a data-toggle=\"collapse\" data-target=\"#footer\" class=\"text-center collapsed\"><i class=\"icon-circle-up2\"></i></a></li></ul><div id=\"footer\" class=\"navbar-collapse collapse\"><div class=\"navbar-text\">© 2018<translate>ALL_RIGHTS_RESERVED</translate>. <a href=\"{{ \'TAGLME_TERMS\' | translate}}\" target=\"_blank\" translate=\"\">TERMS</a></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=\"navbar navbar-inverse navbar-custom navbar-static-top\"><div class=\"navbar-header\"><a href=\"{{\'TAGLME_INDEX\' | translate}}\" target=\"_blank\" class=\"navbar-brand\"><img style=\"height: 45px; margin-top: -14px;\" src=\"/assets/images/logo.png\"></a><ul class=\"nav navbar-nav pull-right visible-xs-block\"><li><a data-toggle=\"collapse\" data-target=\"#navbar-mobile\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><i class=\"fa fa-toggle-down\"></i></a></li><li><a class=\"sidebar-mobile-main-toggle\"><i class=\"fa fa-bars\"></i></a></li></ul></div><div id=\"navbar-mobile\" class=\"collapse navbar-collapse\" ng-class=\"{\'tagl-navbar-center\': !vm.$state.current.appNavBar}\" collapse=\"navCollapsed\"><ul class=\"nav navbar-nav navbar-right\" ng-if=\"!vm.$state.current.appNavBar\"><li dropdown=\"\" dropdown-nav=\"\"><a href=\"#\" dropdown-toggle=\"\" tooltip=\"Change language\" tooltip-placement=\"bottom\"><span class=\"current-language\">{{vm.currentLang}}</span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"language in vm.languages\"><a href=\"#\" ng-click=\"vm.setLanguage(language)\">{{language}}</a></li></ul></li><li ng-hide=\"vm.userName\"><a ui-sref=\"login\" translate=\"\">LOGIN</a></li><li ng-hide=\"vm.userName\"><a ui-sref=\"signup\" translate=\"\">SIGNUP</a></li><li ng-show=\"vm.userName\"><a ui-sref=\"app.encodings\"><i class=\"fa fa-fw fa-user\"></i> {{vm.userName}}</a></li><li ng-show=\"vm.userName\"><a href=\"#\" ng-click=\"vm.logout()\"><i class=\"fa fa-fw fa-sign-out\"></i> {{\'LOGOUT\' | translate}}</a></li></ul><ul class=\"nav navbar-nav navbar-right\" ng-if=\"vm.$state.current.appNavBar\"><li dropdown=\"\" dropdown-nav=\"\"><a href=\"#\" dropdown-toggle=\"\" tooltip=\"Change language\" tooltip-placement=\"bottom\"><span class=\"current-language\">{{vm.currentLang}}</span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"language in vm.languages\"><a href=\"#\" ng-click=\"vm.setLanguage(language)\">{{language}}</a></li></ul></li><li dropdown=\"\" dropdown-nav=\"\"><a dropdown-toggle=\"\"><i class=\"fa fa-th\" aria-hidden=\"true\"></i></a><ul class=\"dropdown-menu\"><li><a href=\"http://console.tagl.me\" target=\"_blank\">CONSOLE</a></li><li><a href=\"#\">ENCODER</a></li><li><a href=\"https://link.tagl.me\" target=\"_blank\">LINK</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"{{ \'TAGLME_DOCS\' | translate}}\" target=\"_blank\">{{\'MENU_HELP\' | translate}}</a></li><li><a href=\"{{ \'TAGLME_FEEDBACK\' | translate}}\" target=\"_blank\">{{\'MENU_FEEDBACK\' | translate}}</a></li></ul></li><li dropdown=\"\" dropdown-nav=\"\" ng-show=\"vm.userName\" class=\"dropdown-user\"><a href=\"#\" dropdown-toggle=\"\"><img alt=\"userpic\" width=\"30\" height=\"30\" src=\"/assets/images/image.png\"> {{vm.userName}} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"userSettings\"><i class=\"fa fa-fw fa-user\"></i> {{\'USER_PROFILE\' | translate}}</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"#\" ng-click=\"vm.logout()\"><i class=\"fa fa-fw fa-sign-out\"></i> {{\'LOGOUT\' | translate}}</a></li></ul></li></ul></div></div><script>\r\n    // Mobile sidebar controls\r\n    // -------------------------\r\n\r\n    // Toggle main sidebar\r\n    $(\'.sidebar-mobile-main-toggle\').on(\'click\', function(e) {\r\n        e.preventDefault();\r\n        $(\'body\').toggleClass(\'sidebar-mobile-main\').removeClass(\'sidebar-mobile-secondary sidebar-mobile-opposite\');\r\n    });\r\n\r\n\r\n    // Toggle secondary sidebar\r\n    $(\'.sidebar-mobile-secondary-toggle\').on(\'click\', function(e) {\r\n        e.preventDefault();\r\n        $(\'body\').toggleClass(\'sidebar-mobile-secondary\').removeClass(\'sidebar-mobile-main sidebar-mobile-opposite\');\r\n    });\r\n\r\n\r\n    // Toggle opposite sidebar\r\n    $(\'.sidebar-mobile-opposite-toggle\').on(\'click\', function(e) {\r\n        e.preventDefault();\r\n        $(\'body\').toggleClass(\'sidebar-mobile-opposite\').removeClass(\'sidebar-mobile-main sidebar-mobile-secondary\');\r\n    });\r\n</script>");
$templateCache.put("app/modals/encode/create.html","<div class=\"modal-header pl-30\"><h4 ng-if=\"!vm.editing\" class=\"modal-title h-grey\" translate=\"\">CREATE_ENCODING</h4><h4 ng-if=\"vm.editing\" class=\"modal-title h-grey\" translate=\"\">EDIT_ENCODING</h4></div><form class=\"form\" ng-submit=\"vm.ok(vm.name, vm.description)\"><div class=\"modal-body pl-30\"><div class=\"form-group\"><label for=\"create-encoding-dialog-name-input\" translate=\"\">ENTER_ENCODING_NAME</label> <input ng-model=\"vm.name\" type=\"text\" class=\"form-control\" placeholder=\"{{ \'GROUP_NAME_PLACEHOLDER\' | translate}}\" required=\"\" id=\"create-encoding-dialog-name-input\"></div><div class=\"form-group\"><label for=\"create-encoding-dialog-desc-input\" translate=\"\">ENTER_ENCODING_DESCRIPTION</label> <textarea ng-model=\"vm.description\" class=\"form-control\" placeholder=\"{{ \'GROUP_DESCRIPTION_PLACEHOLDER\' | translate}}\" id=\"create-encoding-dialog-desc-input\"></textarea></div></div><div class=\"modal-footer\"><div class=\"form-group pull-right\"><button class=\"btn btn-grn\" type=\"submit\" translate=\"\">SAVE</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CANCEL</button></div></div></form>");
$templateCache.put("app/modals/encode/delete.html","<div class=\"modal-header pl-30\"><h4 class=\"modal-title\" translate=\"\">DELETE_GROUP_CONFIRM_DIALOG_TITLE</h4></div><form class=\"form\" ng-submit=\"vm.ok(vm.name, vm.description)\"><div class=\"modal-body pl-30\"><p translate=\"\">DELETE_GROUP_CONFIRM_DIALOG_CONTENT</p><div class=\"form-group\"></div></div><div class=\"modal-footer\"><div class=\"form-group pull-right\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CANCEL</button> <button class=\"btn btn-danger\" type=\"submit\" translate=\"\">DELETE</button></div></div></form>");
$templateCache.put("app/modals/tagconfig/createTag.html","<div class=\"modal-header pl-30\"><h4 class=\"modal-title\"><i class=\"fa fa-fw {{vm.info.icon}}\"></i> {{vm.info.desc | translate}}</h4></div><form class=\"form\" ng-submit=\"vm.ok(vm.name, vm.description)\"><div class=\"modal-body pl-30\"><div class=\"form-group\" ng-repeat=\"(model, field) in vm.optionalFields\"><label ng-if=\"model == \'name\'\" for=\"r-{{model}}\">{{field.desc | translate}}</label> <input ng-if=\"field.type === \'text\' && model == \'name\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.optional[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"text\"></div><h4 class=\"itemHeaderView\" translate=\"\">CONTENT_FIELDS</h4><div class=\"form-group\" ng-repeat=\"(model, field) in vm.requiredFields\"><label for=\"r-{{model}}\">{{field.desc | translate}}</label> <input ng-if=\"field.type === \'text\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.required[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"text\"> <textarea ng-if=\"field.type === \'textarea\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.required[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"text\"></textarea> <input ng-if=\"field.type === \'number\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.required[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"number\"> <input ng-if=\"field.type === \'email\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.required[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"email\"><toggle-switch ng-if=\"field.type === \'boolean\'\" ng-model=\"vm.required[model]\" id=\"r-{{model}}\"></toggle-switch></div><h4 ng-click=\"vm.toogleOptions()\" class=\"mt-30 mPointer text-grn itemHeaderView\"><i ng-if=\"!vm.showOptions\" class=\"fa fa-caret-down\"></i> <i ng-if=\"vm.showOptions\" class=\"fa fa-caret-up\"></i> {{\'OPTIONAL_FIELDS\' | translate}}</h4><div ng-show=\"vm.showOptions\" class=\"form-group\" ng-repeat=\"(model, field) in vm.optionalFields\"><label ng-if=\"model != \'name\' && model != \'encodingOrder\'\" for=\"r-{{model}}\">{{field.desc | translate}}</label> <input ng-if=\"field.type === \'text\' && model != \'name\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.optional[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"text\"> <input ng-if=\"field.type === \'number\' && model != \'encodingOrder\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.optional[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"number\"> <input ng-if=\"field.type === \'email\'\" placeholder=\"{{field.placeholder | translate}}\" ng-model=\"vm.optional[model]\" id=\"r-{{model}}\" ng-required=\"field.require\" class=\"form-control\" type=\"email\"><div ng-if=\"field.type === \'boolean\'\" class=\"pb-10 pt-10\"><toggle-switch ng-model=\"vm.optional[model]\" id=\"r-{{model}}\" class=\"switch-warning\" on-label=\"{{ \'YES\' | translate}}\" off-label=\"{{ \'NO\' | translate}}\"></toggle-switch></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-grn\" type=\"submit\" translate=\"\">SAVE</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CANCEL</button></div></form>");
$templateCache.put("app/modals/tagconfig/deleteTag.html","<div class=\"modal-header pl-30\"><h4 class=\"modal-title\" translate=\"\">DELETE_CONFIG_CONFIRM_DIALOG_TITLE</h4></div><form class=\"form\" ng-submit=\"vm.ok(vm.name, vm.description)\"><div class=\"modal-body pl-30\"><p translate=\"\">DELETE_CONFIG_CONFIRM_DIALOG_CONTENT</p><div class=\"form-group\"></div></div><div class=\"modal-footer\"><div class=\"form-group pull-right\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CANCEL</button> <button class=\"btn btn-danger\" type=\"submit\" translate=\"\">DELETE</button></div></div></form>");
$templateCache.put("app/modals/tagconfig/deleteTags.html","<div class=\"modal-header pl-30\"><h4 class=\"modal-title\" translate=\"\">DELETE_CONFIGS_CONFIRM_DIALOG_TITLE</h4></div><form class=\"form\" ng-submit=\"vm.ok(vm.name, vm.description)\"><div class=\"modal-body pl-30\"><p translate=\"\">DELETE_CONFIGS_CONFIRM_DIALOG_CONTENT</p><div class=\"form-group\"></div></div><div class=\"modal-footer\"><div class=\"form-group pull-right\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CANCEL</button> <button class=\"btn btn-danger\" type=\"submit\" translate=\"\">DELETE</button></div></div></form>");
$templateCache.put("app/modals/tagconfig/viewTag.html","<div class=\"modal-header pl-30\"><h4 class=\"modal-title\"><i class=\"fa fa-fw {{vm.info.icon}}\"></i> {{vm.info.desc | translate}}</h4></div><div class=\"modal-body pl-30\"><div ng-repeat=\"(model, field) in vm.optionalFields\"><div class=\"viewConfigField\" ng-if=\"field.type === \'text\' && model == \'name\' && vm.optional[model]\">{{vm.optional[model]}}</div><p class=\"l-grey\" ng-if=\"model == \'name\' && vm.optional[model]\" for=\"r-{{model}}\">{{field.desc | translate}}</p></div><h4 class=\"itemHeaderView\" translate=\"\">CONTENT_FIELDS</h4><div ng-repeat=\"(model, field) in vm.requiredFields\"><div class=\"viewConfigField\" ng-if=\"field.type === \'text\' && vm.required[model]\">{{vm.required[model]}}</div><div class=\"viewConfigField\" ng-if=\"field.type === \'number\' && vm.required[model]\">{{vm.required[model]}}</div><div class=\"viewConfigField\" ng-if=\"field.type === \'email\' && vm.required[model]\">{{vm.required[model]}}</div><toggle-switch ng-if=\"field.type === \'boolean\'\" ng-model=\"vm.required[model]\" is-disabled=\"true\"></toggle-switch><p class=\"l-grey\" ng-if=\"vm.required[model]\">{{field.desc | translate}}</p></div><h4 ng-click=\"vm.toogleOptions()\" class=\"mt-30 mPointer text-grn itemHeaderView\"><i ng-if=\"!vm.showOptions\" class=\"fa fa-caret-down\"></i> <i ng-if=\"vm.showOptions\" class=\"fa fa-caret-up\"></i> {{\'OPTIONAL_FIELDS\' | translate}}</h4><div ng-show=\"vm.showOptions\" ng-repeat=\"(model, field) in vm.optionalFields\"><div ng-if=\"field.type === \'text\' && model != \'name\' && vm.optional[model]\"><div class=\"viewConfigField\">{{vm.optional[model]}}</div><p class=\"l-grey\">{{field.desc | translate}}</p></div><div ng-if=\"field.type === \'number\' && model != \'encodingOrder\' && vm.optional[model]\"><div class=\"viewConfigField\">{{vm.optional[model]}}</div><p class=\"l-grey\">{{field.desc | translate}}</p></div><div ng-if=\"field.type === \'email\' && vm.optional[model]\"><div class=\"viewConfigField\">{{vm.optional[model]}}</div><p class=\"l-grey\">{{field.desc | translate}}</p></div><div ng-if=\"field.type === \'boolean\' && (vm.optional[model] === true || vm.optional[model] === false )\"><div class=\"pb-10 pt-10\"><toggle-switch ng-model=\"vm.optional[model]\" class=\"switch-warning\" is-disabled=\"true\" on-label=\"{{ \'YES\' | translate}}\" off-label=\"{{ \'NO\' | translate}}\"></toggle-switch></div><p class=\"l-grey\">{{field.desc | translate}}</p></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"vm.cancel()\" translate=\"\">CLOSE</button></div>");
$templateCache.put("app/password/reset/confirm.html","<div class=\"page-container\"><div class=\"page-content login-container\"><div class=\"content-wrapper\"><div class=\"panel panel-body login-form\"><form name=\"confirmFm\" ng-submit=\"confirm.confirmReset(confirm.code, password)\"><div class=\"text-center\"><div class=\"icon-object border-warning text-warning\"><i class=\"fa fa-refresh icon-round\"></i></div><h4 class=\"content-group\">{{\'CONFIRM_RESET_PASSWORD\' | translate }}</h4></div><input type=\"text\" style=\"display:none\"> <input type=\"password\" style=\"display:none\"><fieldset><div class=\"form-group\"><input class=\"form-control\" autocomplete=\"off\" name=\"code2\" type=\"text\" required=\"\" ng-model=\"confirm.code\" placeholder=\"{{ \'RESET_CODE\' | translate }}\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': confirmFm.password.$error.minlength || confirmFm.password.$error.maxlength }\"><input class=\"form-control\" name=\"password\" ng-model=\"password\" placeholder=\"{{\'PASSWORD_SIGN\' | translate}}\" required=\"\" type=\"password\" ng-minlength=\"4\" ng-maxlength=\"54\" value=\"\"><div class=\"clearfix\"><div ng-messages=\"confirmFm.password.$error\"><div ng-message=\"minlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_SHORT\' | translate}}</div><div ng-message=\"maxlength\" class=\"control-label\">{{\'YOUR_PASSWORD_TOO_BIG\' | translate}}</div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': confirmFm.confirmPassword.$error.passwordMatch }\"><input class=\"form-control\" match-password=\"password\" ng-model=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'CONFIRM_PASSWORD\' | translate}}\" type=\"password\" value=\"\"><div class=\"clearfix\"><div ng-messages=\"confirmFm.confirmPassword.$error\"><div ng-message=\"passwordMatch\" class=\"control-label\">{{\'PASSWORD_DID_NOT_MATCH\' | translate}}</div></div></div></div><div class=\"actions\"><input class=\"btn btn-grn btn-block\" name=\"commit\" type=\"submit\" ng-disabled=\"confirmFm.$invalid || !confirmFm.$dirty\" value=\"{{\'SUBMIT_RESET_CODE\' | translate }}\"></div></fieldset></form></div></div></div></div><div ng-include=\"\'app/components/footer/footer.html\'\"></div>");
$templateCache.put("app/app/encoding/tagconfig/tagconfig.html","<div class=\"col-sm-12\"><h4 class=\"h-grey\">{{tagcfg.encoder.name}}</h4><p class=\"l-grey leadText\">{{tagcfg.encoder.description}}</p></div><div class=\"col-sm-12\"><h4 class=\"h-grey\" translate=\"\">CONFIGS_LIST</h4></div><fieldset class=\"col-sm-12\" ng-disabled=\"tagcfg.isLoading()\"><div class=\"form-group\"><div class=\"btn-group\" dropdown=\"\" keyboard-nav=\"\"><button type=\"button\" class=\"btn btn-orange\" dropdown-toggle=\"\">{{\'CREATE\' | translate }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu wide-dropdown\" role=\"menu\"><li ng-repeat=\"(type, typeData) in tagcfg.template.types\"><a href=\"#\" ng-click=\"tagcfg.showCreateModal(type)\"><i class=\"fa fa-fw {{typeData.icon}}\"></i> {{typeData.desc | translate}}</a></li></ul></div>&nbsp; <button class=\"btn btn-danger\" ng-click=\"tagcfg.deleteSelected()\">{{\'DELETE\' | translate}}</button> &nbsp;<div class=\"btn-group\" dropdown=\"\" keyboard-nav=\"\"><button type=\"button\" class=\"btn btn-default\" dropdown-toggle=\"\">{{\'MORE\' | translate}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu wide-dropdown\" role=\"menu\"><li role=\"presentation\"><a ng-click=\"tagcfg.selectAll()\" href=\"#\" role=\"menuitem\" tabindex=\"-1\" class=\"hndlr-tbl-paste\"><i class=\"fa fa-fw fa-list\"></i> {{\'SELECT_ALL\' | translate}}</a></li><li role=\"presentation\" ng-class=\"{\'disabled\': !tagcfg.hasSelection}\"><a ng-click=\"tagcfg.copyEncodings()\" href=\"#\" role=\"menuitem\" tabindex=\"-1\" class=\"hndlr-tbl-copy\"><i class=\"fa fa-fw fa-copy\"></i> {{\'COPY\' | translate}}</a></li><li role=\"presentation\" ng-class=\"{\'disabled\': !tagcfg.hasClipboard}\"><a ng-click=\"tagcfg.pasteConfigs()\" href=\"#\" role=\"menuitem\" tabindex=\"-1\" class=\"hndlr-tbl-paste\"><i class=\"fa fa-fw fa-paste\"></i> {{\'PASTE\' | translate}}</a></li><li><a href=\"#\" ng-click=\"tagcfg.exportSelected()\"><i class=\"fa fa-fw fa-download\"></i> {{\'EXPORT_SELECTED\' | translate}}</a></li></ul></div><div class=\"btn-group pull-right\" dropdown=\"\" keyboard-nav=\"\"><button id=\"simple-btn-keyboard-nav\" type=\"button\" class=\"btn btn-default\" dropdown-toggle=\"\">{{\'SHOW\' | translate}} {{tagcfg.limit}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"limit in [10, 20, 50]\"><a ng-click=\"tagcfg.setLimit(limit)\" href=\"#\" role=\"menuitem\" tabindex=\"-1\">{{limit}}</a></li></ul></div></div></fieldset><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"drag-col\"></th><th class=\"col-lg-1 col-md-1 col-sm-1 center-align\" translate=\"\">ORDER</th><th class=\"col-lg-2 col-md-2 col-sm-2\" translate=\"\">NAME</th><th class=\"col-lg-1 col-md-1 col-sm-1\" translate=\"\">TYPE</th><th class=\"col-lg-4 col-md-4 col-sm-4\" translate=\"\">CONTENT</th><th translate=\"\">CREATED_AT</th><th translate=\"\">ACTIONS</th></tr></thead><tbody ng-if=\"tagcfg.tagConfigs.length != 0\" ng-sortable=\"tagcfg.sortOptions\"><tr ng-repeat=\"tagconfig in tagcfg.tagConfigs\" ng-class=\"{\'selected-row\': tagcfg.selected[tagconfig.id]}\"><td class=\"vcenter-align drag-handler\"><i class=\"fa fa-ellipsis-v handle-row pr-5\"></i> <input type=\"checkbox\" ng-model=\"tagcfg.selected[tagconfig.id]\"></td><td class=\"mPointer vcenter-align center-align\" ng-click=\"tagcfg.view(tagconfig)\">{{ tagconfig.encodingOrder }}</td><td class=\"mPointer vcenter-align\" ng-click=\"tagcfg.view(tagconfig)\">{{ tagconfig.name }}</td><td class=\"mPointer vcenter-align table-icon\" ng-click=\"tagcfg.view(tagconfig)\"><span class=\"ellipsis\" tooltip=\"{{tagcfg.typeDesc(tagconfig) | translate}}\"><i class=\"fa fa-fw {{tagcfg.icon(tagconfig)}}\"></i></span></td><td class=\"mPointer vcenter-align\" ng-click=\"tagcfg.view(tagconfig)\">{{ tagcfg.payloadView(tagconfig) }}</td><td class=\"mPointer vcenter-align\" ng-click=\"tagcfg.view(tagconfig)\">{{ tagconfig.created | date : \'dd/MM/yy HH:mm:ss\' }}</td><td class=\"vcenter-align\"><div class=\"btn-group\" dropdown=\"\" keyboard-nav=\"\"><button type=\"button\" class=\"btn btn-default btn-sm\" dropdown-toggle=\"\">{{\'ACTION\' | translate }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"#\" ng-click=\"tagcfg.edit(tagconfig)\"><i class=\"fa fa-fw fa-pencil\"></i> {{\'EDIT\' | translate}}</a></li><li><a href=\"#\" ng-click=\"tagcfg.exportItem(tagconfig)\"><i class=\"fa fa-fw fa-download\"></i> {{\'EXPORT\' | translate}}</a></li><li><a href=\"#\" ng-click=\"tagcfg.deleteItem(tagconfig.id)\"><i class=\"fa fa-fw fa-trash-o\"></i> {{\'DELETE\' | translate}}</a></li></ul></div></td></tr><tr></tr></tbody><tbody ng-if=\"tagcfg.tagConfigs.length == 0\"><tr><td class=\"pt-10 pb-10 vcenter-align center-align\" colspan=\"7\">{{\'EMPTY_GROUP\' | translate}}</td></tr></tbody><tfoot><tr><td></td><td colspan=\"7\"><pagination ng-disabled=\"tagcfg.isLoading()\" total-items=\"tagcfg.total\" ng-model=\"tagcfg.page\" items-per-page=\"tagcfg.limit\" previous-text=\"{{\'PREVIOUS\' | translate}}\" next-text=\"{{\'NEXT\' | translate}}\" first-text=\"{{\'FIRST\' | translate}}\" last-text=\"{{\'LAST\' | translate}}\" max-size=\"10\" class=\"pagination-sm\" boundary-links=\"true\"></pagination></td></tr></tfoot></table></div>");}]);